// @ts-nocheck
/* Options:
Date: 2023-11-29 16:36:57
Version: 5.10
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://api.test.ownable.uk

//GlobalNamespace: 
//MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
DefaultImports: SortedList from './SortedList'
*/

import SortedList from './SortedList';

export interface IReturn<T>
{
    createResponse() : T;
}

export interface IReturnVoid
{
    createResponse() : void;
}

export interface IPost
{
}

export interface IDelete
{
}

export interface IGet
{
}

export type Actions = "Default" | "Delete" | "Add" | "Copy";

export class BaseRequest
{
    start: number;
    count: number;
    sort: string;
    sortDescending: boolean;
    q: string;
    full: boolean;
    group: string;
    from: string;
    to: string;
    verb: string;
    refresh: boolean;
    flush: boolean;
    noCache: boolean;
    actionName: string;
    theme: string;
    cacheKey: string;
    ownableClient: string;
    isLegacyPortalRequest: boolean;
    action: Actions;
}

export interface IAuthTokens
{
    provider?: string;
    userId?: string;
    accessToken?: string;
    accessTokenSecret?: string;
    refreshToken?: string;
    refreshTokenExpiry?: string;
    requestToken?: string;
    requestTokenSecret?: string;
    items?: { [index:string]: string; };
}

export interface IAuthSession
{
    referrerUrl?: string;
    id?: string;
    userAuthId?: string;
    userAuthName?: string;
    userName?: string;
    displayName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    providerOAuthAccess?: IAuthTokens[];
    createdAt?: string;
    lastModified?: string;
    roles?: string[];
    permissions?: string[];
    isAuthenticated?: boolean;
    fromToken?: boolean;
    authProvider?: string;
    profileUrl?: string;
    sequence?: string;
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1, EmitDefaultValue=false)
    errorCode: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    fieldName: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    message: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    meta: { [index:string]: string; };
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    errorCode: string;

    // @DataMember(Order=2)
    message: string;

    // @DataMember(Order=3)
    stackTrace: string;

    // @DataMember(Order=4)
    errors: ResponseError[];

    // @DataMember(Order=5)
    meta: { [index:string]: string; };
}

// @DataContract
export class BaseResponse
{
    // @DataMember
    responseStatus: ResponseStatus;
}

export class DigitalErrorDTO
{
    errorCode: number;
    hint: string;
    userMessage: string;
}

export class DigitalResponseBase<T>
{
    success: boolean;
    version: string;
    errors: DigitalErrorDTO[];
}

export type MediaResourceType = "Image" | "Mp4VideoClip";

export class MediaContentItemDTO
{
    mediaType: MediaResourceType;
    url: string;
    width: number;
    height: number;
}

export class MediaContentDTO
{
    items: MediaContentItemDTO[];
}

export type BrandConcessionBackgroundMode = "None" | "Colour" | "StretchedImage";

export class BrandConcessionContentHeaderDTO
{
    title: string;
    text: string;
    showHeroMedia: boolean;
    heroImageUrl: string;
    heroMedia: MediaContentDTO;
    backgroundMode: BrandConcessionBackgroundMode;
    backgroundColour: string;
    fontColour: string;
    backgroundImageUrl: string;
    backgroundMedia: MediaContentDTO;
}

export type BrandSectionTemplateType = "NotSet" | "Header" | "HeroLeft" | "HeroRight" | "Merchandiser5" | "Merchandiser4" | "Merchandiser3" | "HeroAndText" | "ThreeUp" | "ProductShelf";

export class BrandConcessionContentProductDTO
{
    id: number;
    name: string;
    imageUrl: string;
}

export class BrandConcessionContentSectionDTO
{
    id: number;
    template: BrandSectionTemplateType;
    title: string;
    text: string;
    linkButtonTitle: string;
    linkButtonUrl: string;
    heroImageUrl: string;
    heroMedia: MediaContentDTO;
    products: BrandConcessionContentProductDTO[];
    backgroundMode: BrandConcessionBackgroundMode;
    backgroundColour: string;
    fontColour: string;
    backgroundImageUrl: string;
    backgroundMedia: MediaContentDTO;
}

export class BrandConcessionContentJumpDTO
{
    concessionId: number;
    title: string;
    imageUrl: string;
    heroMedia: MediaContentDTO;
}

export class BrandConcessionContentDTO
{
    concessionId: number;
    brandId: number;
    brandName: string;
    departmentId: number;
    departmentName: string;
    floorId: number;
    floorName: string;
    header: BrandConcessionContentHeaderDTO;
    sections: BrandConcessionContentSectionDTO[];
    jumps: BrandConcessionContentJumpDTO[];
}

export class ProductSetContentProductDTO
{
    id: number;
    name: string;
    imageUrl: string;
}

export class ProductSetContentDTO
{
    productSetId: number;
    departmentId: number;
    departmentName: string;
    floorId: number;
    floorName: string;
    title: string;
    text: string;
    heroImageUrl: string;
    products: ProductSetContentProductDTO[];
}

export class FeatureableBrandDTO
{
    id: number;
    name: string;
}

export class BrandFeatureProductDTO
{
    id: number;
    name: string;
    imageUrl: string;
}

export class BrandFeatureSectionDTO
{
    featureSectionId: number;
    brandFeatureId: number;
    name: string;
    title: string;
    imageUrl: string;
    summaryText: string;
    sortOrder: number;
    products: BrandFeatureProductDTO[];
    hidden: boolean;
    templateId: number;
    linkUrl: string;
    backgroundMode: BrandConcessionBackgroundMode;
    backgroundColour: string;
    fontColour: string;
    backgroundImageUrl: string;
}

export class BrandFeatureDTO
{
    brandFeatureId: number;
    brandId: number;
    floorId: number;
    floorName: string;
    newsstandSubjectId: number;
    newsstandSubjectName: string;
    teaserProducts: BrandFeatureProductDTO[];
    title: string;
    subTitle: string;
    imageUrl: string;
    summaryText: string;
    navigationTextTemplate: string;
    showHeroMediaInHeaderOption: boolean;
    headerBackgroundMode: BrandConcessionBackgroundMode;
    headerBackgroundColour: string;
    headerFontColour: string;
    headerBackgroundImageUrl: string;
    hidden: boolean;
    sections: BrandFeatureSectionDTO[];
}

export class BrandFeaturesDTO
{
    brandId: number;
    brandName: string;
    imageUrl: string;
    description: string;
    hidden: boolean;
    features: BrandFeatureDTO[];
}

export class BrandFeatureSectionTemplateDTO
{
    id: number;
    name: string;
    description: string;
    requirements: string;
}

export class BrandFeatureFloorDTO
{
    floorId: number;
    floorName: string;
}

export class ProductSetFeatureProductDTO
{
    id: number;
    name: string;
    brandId: number;
    brandName: string;
    imageUrl: string;
}

export class ProductSetFeatureDTO
{
    id: number;
    name: string;
    summaryText: string;
    imageUrl: string;
    hidden: boolean;
    sortOrder: number;
    floorId: number;
    floorName: string;
    departmentId: number;
    departmentName: string;
    teaserProducts: ProductSetFeatureProductDTO[];
    products: ProductSetFeatureProductDTO[];
}

export class ProductBrandDTO
{
    id: number;
    name: string;
}

export class ContentManagerEditionDTO
{
    id: number;
    name: string;
    created: string;
    published: string;
    productCount: number;
}

export class ProductSetFloorDTO
{
    floorId: number;
    floorName: string;
}

export class ProductSetIdentityDTO
{
    id: number;
    name: string;
}

export type FloorDisplayType = "Unspecified" | "BrandConcession" | "ProductSet";

export class FloorDepartmentDTO
{
    departmentId: number;
    name: string;
    blockCoordinates: number[];
}

export class FloorDTO
{
    id: number;
    name: string;
    floorNumber: number;
    width: number;
    height: number;
    displayType: FloorDisplayType;
    isDefault: boolean;
    departments: FloorDepartmentDTO[];
}

export type FloorPlanDisplayGutterStyle = "None" | "Top" | "Bottom" | "Right";

export class FloorContentTeaserProductDTO
{
    id: number;
    name: string;
    imageUrl: string;
    media: MediaContentDTO;
}

export class FloorContentCellDTO
{
    departmentId: number;
    isFocusPoint: boolean;
    x: number;
    y: number;
    displayId: number;
    displayGutterStyle: FloorPlanDisplayGutterStyle;
    heroImageUrl: string;
    heroMedia: MediaContentDTO;
    displayTitle: string;
    displaySubTitle: string;
    products: FloorContentTeaserProductDTO[];
}

export class FloorContentDTO
{
    floorId: number;
    floorName: string;
    displayType: FloorDisplayType;
    width: number;
    height: number;
    cells: FloorContentCellDTO[];
    pathwaysHorizontal: number[];
    pathwaysVertical: number[];
}

export class TitlePublisherDTO
{
    id: number;
    name: string;
}

export class ContentManagerTitleGroupDTO
{
    id: number;
    name: string;
}

export type ProductState = "Unknown" | "Basic" | "Complete" | "Verified" | "Excluded";

export type ProductAdminStatusFlag = "None" | "Hidden" | "Uncategorised" | "Unbranded" | "Unverified";

export class ContentManagerProductDTO
{
    id: number;
    name: string;
    brand: string;
    imageUrl: string;
    captureState: ProductState;
    statusFlags: ProductAdminStatusFlag[];
}

export class ContentManagerPageDTO
{
    id: number;
    name: string;
    pageNumber: number;
    products: ContentManagerProductDTO[];
}

export class HistoryOrderItemDTO
{
    id: number;
    productId: number;
    productName: string;
    productBrand: string;
    productOption: string;
    productPrice: number;
    productImageUrl: string;
    quantity: number;
}

export class HistoryOrderDTO
{
    id: number;
    orderNumber: string;
    created: string;
    status: string;
    deliveryRecipient: string;
    deliveryStreet: string;
    deliveryTownOrCity: string;
    deliveryCounty: string;
    deliveryPostcode: string;
    items: HistoryOrderItemDTO[];
    paymentMethodDescription: string;
    orderSubTotal: number;
    deliveryCharge: number;
    orderTotal: number;
    cancelVerb: string;
}

export class SavedAddressDTO
{
    id: number;
    displayName: string;
    isDefault: boolean;
    recipientName: string;
    street: string;
    townOrCity: string;
    county: string;
    postcode: string;
    phone: string;
}

export class SavedCardDTO
{
    id: number;
    isDefault: boolean;
    displayName: string;
    cardType: string;
    last4Digits: string;
}

export class UserOrderSummaryDTO
{
    itemProductId: number;
    itemName: string;
    itemBrand: string;
    itemOptionId: number;
    itemOptionName: string;
    itemPrice: number;
    itemQuantity: number;
    itemImageUrl: string;
    subtotal: number;
    deliveryCharge: number;
    orderTotal: number;
    savedAddresses: SavedAddressDTO[];
    savedCards: SavedCardDTO[];
}

export class UserOrderDeliveryDetailsDTO
{
    savedAddressId: number;
    recipientName: string;
    phoneNumber: string;
    street: string;
    townOrCity: string;
    county: string;
    postCode: string;
    saveAddress: boolean;
    saveAddressAs: string;
    setAddressAsDefault: boolean;
}

export class UserOrderPaymentDetailsDTO
{
    savedCardId: number;
    paymentMethodId: string;
    saveCard: boolean;
    saveCardAs: string;
    setCardAsDefault: boolean;
}

export type ConfirmUserOrderStatus = "Error" | "PaymentSuccessful" | "PaymentAuthenticationRequired" | "CardDeclined";

export class UserOrderConfirmationDTO
{
    orderId: number;
    orderNumber: string;
    postage: number;
    subtotal: number;
    total: number;
}

export type ProductPrimaryAction = "Buy" | "VisitBrand" | "ClickAndCollect" | "PutAside" | "RequestInfo" | "BookTable" | "Unavailable";

export class MediaDefinitionDTO
{
    mediaKey: string;
    thumbnailUrl: string;
    rawUrl: string;
}

export class ProductOptionValueDefinitionDTO
{
    id: number;
    name: string;
    rrp: number;
    price: number;
    postage: number;
    media: MediaDefinitionDTO;
}

export class ProductOptionsDefinitionDTO
{
    optionKey: string;
    defaultOptionName: string;
    optionValues: ProductOptionValueDefinitionDTO[];
}

export class ProductDefinitionDTO
{
    id: number;
    name: string;
    description: string;
    purchaseUrl: string;
    brandId: number;
    categoryId: number;
    price: number;
    priceLabel: string;
    rrp: number;
    currency: string;
    unit: string;
    postage: number;
    published: boolean;
    bigBrowse: boolean;
    primaryAction: ProductPrimaryAction;
    actions: ProductPrimaryAction[];
    options: ProductOptionsDefinitionDTO;
    media: MediaDefinitionDTO[];
}

export type ProductFormMode = "Unspecified" | "ContentManager" | "BrandConcessionEditor" | "Visualiser" | "Legacy";

export class CreateProductMediaDTO
{
    mediaBase64: string;
    mediaContentType: string;
}

export class CreateProductOptionValueDTO
{
    name: string;
    rrp: number;
    price: number;
    postage: number;
    media: CreateProductMediaDTO;
}

export class CreateProductOptionsDTO
{
    optionKey: string;
    defaultOptionName: string;
    optionValues: CreateProductOptionValueDTO[];
}

export class CreateProductDTO
{
    name: string;
    description: string;
    purchaseUrl: string;
    brandId: number;
    categoryId: number;
    price: number;
    priceLabel: string;
    rrp: number;
    currency: string;
    unit: string;
    postage: number;
    publish: boolean;
    primaryActions: ProductPrimaryAction[];
    options: CreateProductOptionsDTO;
    media: CreateProductMediaDTO[];
    editionPageId: number;
}

export class UpdateProductMediaDTO
{
    mediaKey: string;
    mediaBase64: string;
    mediaContentType: string;
    update: boolean;
}

export class UpdateProductOptionValueDTO
{
    id: number;
    name: string;
    rrp: number;
    price: number;
    postage: number;
    media: UpdateProductMediaDTO;
    update: boolean;
}

export class UpdateProductOptionsDTO
{
    optionKey: string;
    defaultOptionName: string;
    optionValues: UpdateProductOptionValueDTO[];
}

export class UpdateProductDTO
{
    id: number;
    name: string;
    description: string;
    purchaseUrl: string;
    brandId: number;
    categoryId: number;
    price: number;
    priceLabel: string;
    rrp: number;
    currency: string;
    unit: string;
    postage: number;
    bigBrowse: boolean;
    publish: boolean;
    primaryActions: ProductPrimaryAction[];
    options: UpdateProductOptionsDTO;
    media: UpdateProductMediaDTO[];
}

export class ProductPrimaryActionDTO
{
    id: number;
    name: string;
    displayName: string;
}

export class ProductCategoryDTO
{
    id: number;
    name: string;
}

export class ProductImageDTO
{
    id: string;
    thumbnailUrl: string;
}

export class ProductDetailForEditDTO
{
    productId: number;
    published: boolean;
    postage: number;
    referralUrl: string;
    images: ProductImageDTO[];
    bigBrowse: boolean;
}

export class ProductDetailsActionDTO
{
    id: number;
    type: string;
    displayName: string;
    url: string;
}

export class ProductDetailsOptionDTO
{
    baseProduct: boolean;
    id: number;
    name: string;
    rrp: number;
    price: number;
    imageUrl: string;
}

export class ProductDetailsDTO
{
    id: number;
    name: string;
    brand: string;
    featuredIn: string;
    description: string;
    rrp: number;
    priceLabel: string;
    price: number;
    unit: string;
    imageUrls: string[];
    actions: ProductDetailsActionDTO[];
    optionsLabel: string;
    options: ProductDetailsOptionDTO[];
}

export class UserRoleDTO
{
    roleIdentifier: string;
    parameter: number;
}

export class UserRoleInstanceDTO
{
    roleIdentifier: string;
    displayName: string;
    hasParameter: boolean;
    parameter: number;
    isAdminRole: boolean;
}

export class UserDetailDTO
{
    id: number;
    email: string;
    fullName: string;
    marketingConsent: boolean;
    roles: UserRoleInstanceDTO[];
    savedAddresses: SavedAddressDTO[];
    savedCards: SavedCardDTO[];
}

export class UserSummaryDTO
{
    id: number;
    name: string;
    email: string;
    created: string;
    lastLogin: string;
}

export class UserRoleDefinitionDTO
{
    roleIdentifier: string;
    displayName: string;
    requiresParameter: boolean;
    isAdminRole: boolean;
}

export class RoleParameterOptionDTO
{
    parameterValue: number;
    displayName: string;
}

export class UserListDTO
{
    id: number;
    name: string;
    containsProduct: boolean;
}

export class UserPreferencesSmartBrowsingDTO
{
    smartBrowsingActive: boolean;
    smartBrowsingDeactivationWarning: boolean;
}

export class UserPreferencesDTO
{
    smartBrowsing: UserPreferencesSmartBrowsingDTO;
}

export interface IUserSettingsRequest
{
    token?: string;
}

export class VisualiserFloorPlanCellDTO
{
    departmentId: number;
    departmentHidden: boolean;
    title: string;
    x: number;
    y: number;
}

export class VisualiserFloorPlanDTO
{
    floorId: number;
    width: number;
    height: number;
    cells: VisualiserFloorPlanCellDTO[];
    pathwaysHorizontal: number[];
    pathwaysVertical: number[];
}

export class VisualiserDepartmentPlanCellDTO
{
    displayId: number;
    displayGutterStyle: FloorPlanDisplayGutterStyle;
    displayHidden: boolean;
    departmentId: number;
    isFocusPoint: boolean;
    title: string;
    subTitle: string;
    x: number;
    y: number;
}

export class VisualiserDepartmentPlanDTO
{
    floorId: number;
    departmentId: number;
    width: number;
    height: number;
    cells: VisualiserDepartmentPlanCellDTO[];
}

export class VisualiserDepartmentDTO
{
    id: number;
    floorId: number;
    name: string;
    hidden: boolean;
    brandCount: number;
}

export class VisualiserFloorDTO
{
    id: number;
    name: string;
    displayName: string;
    displayType: FloorDisplayType;
    default: boolean;
    hidden: boolean;
    floorNumber: number;
    brandCount: number;
    pendingDisplaysCount: number;
    sortOrder: number;
}

export class OwnableDepartmentDTO
{
    id: number;
    floorId: number;
    name: string;
    hidden: boolean;
}

export class VisualiserDisplayDTO
{
    id: number;
    name: string;
    title: string;
    displayType: FloorDisplayType;
    floorId: number;
    floorName: string;
    departmentId: number;
    departmentName: string;
    hidden: boolean;
    brandCount: number;
    brandId: number;
}

export class BreakdownCategoryDTO
{
    categoryName: string;
    count: number;
    percentage: number;
}

export class EditionProductRetailValueStatsDTO
{
    websiteId: number;
    totalProductCount: number;
    totalPageCount: number;
    minProductValue: number;
    maxProductValue: number;
    averageProductValue: number;
    totalProductValue: number;
    averageTotalProductValuePerPage: number;
    circulation: number;
    opportunitiesToSee: number;
    opportunitiesToSeeTotalValue: number;
}

export class EditionReferralEventRetailValueStatsDTO
{
    websiteId: number;
    productValueOfProductSummaryViews: number;
    productValueOfProductDetailViews: number;
    productValueOfProductSaves: number;
    productValueOfReferralClicks: number;
    productValueOfFastTrackClicks: number;
}

export class WebsiteSummaryStatsDTO
{
    sortOrder: number;
    month: string;
    monthString: string;
    eventCounts: { [index:string]: number; };
}

export type LogEventLevels = "System" | "Error" | "Warning" | "Information" | "Debug" | "Analytics";

export type LogEventTypes = "None" | "PublishedWebsite" | "Catalogue" | "SendBrandMessage";

export class LogEvent
{
    id: number;
    created: string;
    userId: number;
    eventLevel: LogEventLevels;
    // @Ignore()
    eventType: LogEventTypes;

    // @StringLength(60)
    category: string;

    // @StringLength(60)
    action: string;

    // @StringLength(60)
    label: string;

    // @StringLength(60)
    labelId: number;

    // @StringLength(250)
    message: string;

    // @StringLength(48)
    ip: string;
}

export class ThumbnailDTO
{
    url: string;
}

export class MediaDTO
{
    id: string;
    sku: string;
    originalFilename: string;
    contentType: string;
    contentLength: number;
    url: string;
    cdnKey: string;
    caption: string;
    width: number;
    height: number;
    displayAspectRatio: number;
    duration: number;
    isThumbnail: boolean;
    isMain: boolean;
    base64: string;
    thumbnails: { [index:number]: ThumbnailDTO; };
    delete: boolean;
}

export class OrderProductDTO
{
    id: number;
    supplierId: number;
    distributorId: number;
    distributorFee: number;
    name: string;
    sku: string;
    brand: string;
    notReturnable: boolean;
    notReturnableReason: string;
    media: MediaDTO;
    purchaseUrl: string;
    productLinkUrl: string;
    source: string;
    sourceSupplier: string;
}

export class Address
{
    // @StringLength(80)
    poBox: string;

    // @StringLength(240)
    street: string;

    // @StringLength(60)
    locality: string;

    // @StringLength(60)
    region: string;

    // @StringLength(20)
    postcode: string;

    // @StringLength(2)
    country: string;
}

export class OrderSupplier
{
    id: number;
    // @StringLength(120)
    name: string;

    address: Address;
}

export class OrderPublisher
{
    id: number;
    name: string;
    address: Address;
}

export class Source
{
    websiteId: number;
    articleId: number;
    pageId: number;
    // @StringLength(180)
    url: string;

    // @StringLength(60)
    publisher: string;

    // @StringLength(40)
    gaTrackingId: string;

    // @StringLength(40)
    gaPrefix: string;

    // @StringLength(180)
    name: string;

    // @StringLength(180)
    websiteName: string;

    // @StringLength(180)
    pageName: string;

    pageNumber: number;
    // @StringLength(180)
    title: string;

    websiteUrl: string;
    productId: number;
}

export type ShipTo = "Customer" | "Hub";

export class BaseOrderItemDTO
{
    id: string;
    name: string;
    myThingId: number;
    productId: number;
    variantId: string;
    supplierId: number;
    distributorId: number;
    distributorAssigned: boolean;
    distributorAccepted: boolean;
    distributorPaymentId: number;
    publisherId: number;
    product: OrderProductDTO;
    supplier: OrderSupplier;
    distributor: OrderSupplier;
    publisher: OrderPublisher;
    source: Source;
    price: number;
    quantity: number;
    unit: string;
    net: number;
    tax: number;
    postage: number;
    total: number;
    status: number;
    deliveryDate: string;
    trackingMethod: string;
    trackingId: string;
    refundReason: string;
    options: { [index:string]: string; };
    shipTo: ShipTo;
}

export class OrderVoucherDTO
{
    id: number;
    orderId: number;
    supplierId: number;
    voucherId: number;
    code: string;
    amount: number;
}

export type OrderStatus = "Cart" | "New" | "SupplierRejected" | "SupplierAccepted" | "CardPaymentAwaitingAuthentication" | "CardPaymentFailed" | "CardPaymentTaken" | "Accepted" | "RefundRequested" | "RefundDenied" | "RefundAccepted" | "Refunded" | "Cancelled" | "Submitted" | "AwaitingPaymentAuthentication" | "AwaitingPaymentProcessing" | "PaymentFailed" | "UserCancelled" | "OwnableCancelled" | "FundsExpired" | "FundsHeld" | "FundsCaptured";

// @Flags()
export enum OrderHistoryVisibility
{
    Grapemark = 1,
    Customer = 2,
    Supplier = 4,
    Distributor = 8,
    Publisher = 16,
}

export class OrderHistoryDTO
{
    id: number;
    orderId: number;
    created: string;
    visibility: OrderHistoryVisibility;
    message: string;
    data: string;
}

export class BaseOrderDTO
{
    id: number;
    userId: number;
    orderNo: string;
    created: string;
    items: BaseOrderItemDTO[];
    vouchers: OrderVoucherDTO[];
    description: string;
    price: number;
    postage: number;
    net: number;
    tax: number;
    discount: number;
    total: number;
    currency: string;
    paidDate: string;
    when: string;
    status: number;
    statusName: OrderStatus;
    history: OrderHistoryDTO[];
}

export class OrderItemDTO extends BaseOrderItemDTO
{
    platformFee: number;
    platformFeeNet: number;
    platformFeeTax: number;
    distributorCostPrice: number;
    distributorCostPostage: number;
    distributorCostNet: number;
    distributorCostTax: number;
    distributorCostTotal: number;
    supplierBalance: number;
    publisherFee: number;
    publisherFeeNet: number;
    publisherFeeTax: number;
}

export class OrderUserDTO
{
    displayName: string;
    email: string;
}

export class Recipient
{
    id: number;
    // @StringLength(80)
    name: string;

    userId: number;
    isDefault: boolean;
    // @StringLength(120)
    fullName: string;

    address: Address;
    // @StringLength(120)
    email: string;

    // @StringLength(60)
    phone: string;
}

export class OrderDTO extends BaseOrderDTO
{
    items: OrderItemDTO[];
    vouchers: OrderVoucherDTO[];
    user: OrderUserDTO;
    email: string;
    recipient: Recipient;
    paymentMethod: string;
    platformFee: number;
    platformFeeNet: number;
    platformFeeTax: number;
    supplierBalance: number;
    distributorCostPrice: number;
    distributorCostPostage: number;
    distributorCostNet: number;
    distributorCostTax: number;
    distributorCostTotal: number;
    publisherFee: number;
    processorName: string;
    processorTx: string;
    processorData: string;
}

export class PagingResponse extends BaseResponse
{
    count: number;
    total: number;
    start: number;
    sort: string;
    sortDescending: boolean;
}

export class PublisherOrderItemWithOrderDTO extends BaseOrderItemDTO
{
    margin: number;
    publisherFee: number;
    userId: number;
    orderNo: string;
    created: string;
    orderNet: number;
    orderTax: number;
    orderPostage: number;
    orderTotal: number;
    currency: string;
    paidDate: string;
}

export class UserOrderItemDTO extends BaseOrderItemDTO
{
}

export class UserOrderDTO extends BaseOrderDTO
{
    items: UserOrderItemDTO[];
    recipient: Recipient;
    paymentMethod: string;
}

export class PurchasesFilter
{
    when: string;
    startDate: string;
    endDate: string;
    supplierIds: number[];
    websiteIds: number[];
}

export type PaymentTypes = "None" | "Card" | "Bank" | "PayPal" | "Stripe" | "Account" | "Other";

export type SupplierRole = "Supplier" | "Reseller" | "Fullfiller" | "Catalog";

export type WebsiteTypes = "Absolute" | "Responsive" | "Simple";

export class PublisherDTO
{
    id: number;
    name: string;
    created: string;
    description: string;
    url: string;
    address: Address;
    phone: string;
    email: string;
    contactName: string;
    media: MediaDTO[];
    taxNumber: string;
    activeGroupsCount: number;
    defaultWebsiteType: WebsiteTypes;
}

export class PublisherSupplierDTO
{
    publisherId: number;
    supplierId: number;
    supplier: SupplierDTO;
    publisher: PublisherDTO;
    share: number;
}

export class SupplierDTO
{
    id: number;
    name: string;
    supplierTypeId: number;
    created: string;
    description: string;
    url: string;
    address: Address;
    phone: string;
    email: string;
    emailVerified: boolean;
    contactName: string;
    media: MediaDTO[];
    taxNumber: string;
    paymentType: PaymentTypes;
    paymentAccount: string;
    parentSupplierId: number;
    parentPublisherId: number;
    parentWebsiteId: number;
    supplierRole: SupplierRole;
    autoAccept: boolean;
    preferredAffiliateSchemeId: number;
    distributors: SupplierDistributorDTO[];
    publishers: PublisherSupplierDTO[];
    returnsUrl: string;
    termsUrl: string;
    tradeUrl: string;
    defaultDeliveryCharge: number;
    freeDeliveryThreshold: number;
    additionalWebsites: string[];
}

export class SupplierDistributorDTO
{
    supplierId: number;
    distributorId: number;
    distributor: SupplierDTO;
    discount: number;
}

export class TicketDTO
{
    id: number;
    created: string;
    lastUpdated: string;
    type: string;
    status: string;
    subject: string;
    description: string;
    orderId: number;
    orderItemId: number;
    customerId: number;
    supplierId: number;
    distributorId: number;
    externalId: string;
    externalUrl: string;
}

export class OrderBidder extends OrderSupplier
{
    discount: number;
}

export type OrderBidStatus = "New" | "Modified" | "Accepted" | "Rejected";

export class OrderBidDTO
{
    id: number;
    orderId: number;
    orderItemId: number;
    created: string;
    name: string;
    productId: number;
    variantId: string;
    source: Source;
    supplier: OrderBidder;
    quantity: number;
    unit: string;
    price: number;
    postage: number;
    currency: string;
    net: number;
    tax: number;
    total: number;
    status: OrderBidStatus;
    deliveryDate: string;
    returnDays: number;
    referral: string;
    payment: string;
}

export class OrderMatchDTO
{
    id: number;
    orderId: number;
    orderItemId: number;
    supplierId: number;
    supplier: OrderBidder;
}

export class SupplierOrderItemDTO extends BaseOrderItemDTO
{
    platformFee: number;
    platformFeeNet: number;
    platformFeeTax: number;
    supplierBalance: number;
    distributorCostPrice: number;
    distributorCostPostage: number;
    distributorCostNet: number;
    distributorCostTax: number;
    distributorCostTotal: number;
    publisherFee: number;
    publisherFeeNet: number;
    publisherFeeTax: number;
    supplierNet: number;
    supplierTax: number;
    supplierTotal: number;
    bids: OrderBidDTO[];
    matches: OrderMatchDTO[];
}

export class SupplierOrderDTO extends BaseOrderDTO
{
    items: SupplierOrderItemDTO[];
    recipient: Recipient;
    user: OrderUserDTO;
    email: string;
    platformFee: number;
    platformFeeNet: number;
    platformFeeTax: number;
    supplierBalance: number;
    distributorCostPrice: number;
    distributorCostPostage: number;
    distributorCostNet: number;
    distributorCostTax: number;
    distributorCostTotal: number;
    publisherFee: number;
    publisherFeeNet: number;
    publisherFeeTax: number;
}

export type LedgerAccounts = "Platform" | "Customer" | "Supplier" | "Distributor" | "Publisher";

export class LedgerDTO
{
    id: number;
    account: LedgerAccounts;
    name: string;
    description: string;
    created: string;
    orderId: number;
    orderItemId: number;
    customerId: number;
    supplierId: number;
    distributorId: number;
    publisherId: number;
    currency: string;
    amount: number;
    payoutDate: string;
    payoutType: PaymentTypes;
    payoutAccount: string;
    payoutRef: string;
}

export class EditionSummaryDTO
{
    websiteId: number;
    websiteName: string;
    publisherId: number;
    publisherName: string;
    publisherGroupId: number;
    publisherGroupName: string;
    dueDate: string;
    pageCount: number;
    capturedPageCount: number;
    productCount: number;
    productTeamName: string;
    adTeamName: string;
    productSummaryViewCount: number;
    productDetailViewCount: number;
    referralClickCount: number;
}

export type ReferralTypes = "None" | "ProductReferral" | "ProductView" | "ProductSave" | "PageView" | "ProductSummaryView" | "ProductDetailView" | "ProductFastTrackRed" | "ProductFastTrackGrey" | "NewsstandView" | "MagazineView" | "OrderConfirm" | "OrderCancel" | "ProductAttributeSelect" | "DeepLink" | "ProductSummaryViewed" | "ProductDetailViewed" | "FastTrackClick" | "AppLoad";

export interface IPopularityStatsRequest
{
    publisherId?: number;
    publisherGroupId?: number;
    sortBy?: ReferralTypes;
    sortAscending?: boolean;
    since?: string;
}

export class ProductPopularityDTO
{
    productId: number;
    name: string;
    productTypeId: number;
    productType: string;
    brand: string;
    websiteId: number;
    websiteName: string;
    preferredSupplierId: number;
    preferredSupplier: string;
    summaryViewCount: number;
    detailViewCount: number;
    saveCount: number;
    referralCount: number;
    fastTrackCount: number;
    summaryViewPercentage: number;
    detailViewPercentage: number;
    savePercentage: number;
    referralPercentage: number;
    fastTrackPercentage: number;
    isUncategorised: boolean;
}

export class ProductBrandPopularityDTO
{
    brand: string;
    summaryViewCount: number;
    detailViewCount: number;
    saveCount: number;
    referralCount: number;
    fastTrackCount: number;
    summaryViewPercentage: number;
    detailViewPercentage: number;
    savePercentage: number;
    referralPercentage: number;
    fastTrackPercentage: number;
    isUncategorised: boolean;
}

export class ProductTypePopularityDTO
{
    productTypeId: number;
    productType: string;
    summaryViewCount: number;
    detailViewCount: number;
    saveCount: number;
    referralCount: number;
    fastTrackCount: number;
    summaryViewPercentage: number;
    detailViewPercentage: number;
    savePercentage: number;
    referralPercentage: number;
    fastTrackPercentage: number;
    isUncategorised: boolean;
}

export class ProductSupplierPopularityDTO
{
    supplierId: number;
    supplierName: string;
    summaryViewCount: number;
    detailViewCount: number;
    saveCount: number;
    referralCount: number;
    fastTrackCount: number;
    summaryViewPercentage: number;
    detailViewPercentage: number;
    savePercentage: number;
    referralPercentage: number;
    fastTrackPercentage: number;
    isUncategorised: boolean;
}

export class PublisherAffiliateRevenueStatsDTO
{
    commissionId: number;
    publisherId: number;
    publisherGroupId: number;
    date: string;
    affiliate: string;
    merchant: string;
    originatingSource: string;
    page: string;
    orderValue: number;
    revenue: number;
    revenueShare: number;
}

export class EditionSummaryStatsDTO
{
    websiteId: number;
    editionName: string;
    eventCounts: { [index:string]: number; };
}

export class ReferralsCsvRowDTO
{
    id: number;
    created: string;
    userId: number;
    userEmail: string;
    userFirstName: string;
    userLastName: string;
    userDisplayName: string;
    type: string;
    productId: number;
    productName: string;
    productBrand: string;
    productType: string;
    productPrice: number;
    productUrl: string;
    websiteId: number;
    website: string;
    pageNumber: number;
    supplierId: number;
    supplier: string;
    url: string;
    client: string;
}

export class UserDTO
{
    id: number;
    userName: string;
    email: string;
    displayName: string;
    firstName: string;
    lastName: string;
    createdDate: string;
    roles: string[];
    permissions: string[];
    isAuthenticated: boolean;
    lastLoginAttempt: string;
    meta: { [index:string]: string; };
}

export class ReferralWebsite
{
    id: number;
    name: string;
    url: string;
    publisherId: number;
}

export class ReferralPublisher
{
    id: number;
    name: string;
}

export class ReferralSupplier
{
    id: number;
    name: string;
    address: Address;
}

export class ReferralDTO
{
    id: number;
    created: string;
    userId: number;
    user: UserDTO;
    type: ReferralTypes;
    title: string;
    productId: number;
    product: OrderProductDTO;
    thingType: string;
    thingId: number;
    websiteId: number;
    pageNumber: number;
    website: ReferralWebsite;
    publisher: ReferralPublisher;
    supplierId: number;
    supplier: ReferralSupplier;
    url: string;
    data: string;
}

export class Owed
{
    id: string;
    name: string;
    account: LedgerAccounts;
    lastPayout: string;
    currency: string;
    paid: number;
    balance: number;
    balance0: number;
    balance14: number;
    balance30: number;
    balance60: number;
    balance90: number;
}

export class AvailableOrderDTO
{
    orderId: number;
    orderNo: string;
    created: string;
    currency: string;
    address: Address;
    orderItemId: number;
    name: string;
    myThingId: number;
    productId: number;
    variantId: string;
    supplierId: number;
    product: OrderProductDTO;
    supplier: OrderSupplier;
    source: Source;
    quantity: number;
    unit: string;
    productTypeId: number;
    brand: string;
    options: { [index:string]: string; };
}

export class PublicUserDTO
{
    id: number;
    userName: string;
    email: string;
    displayName: string;
    firstName: string;
    lastName: string;
}

// @Flags()
export enum Permissions
{
    Private,
    Public,
}

export type AffiliateSchemeProviderName = "Default" | "Skimlinks" | "SportsBikeShop" | "Awin" | "CJ" | "Webgains" | "Impact";

export class AffiliateSchemeDTO
{
    id: number;
    provider: AffiliateSchemeProviderName;
    merchantName: string;
    created: string;
    modified: string;
    invalidated: string;
}

export class SupplierTypeDTO
{
    id: number;
    name: string;
}

export class StripeState
{
    type: string;
    id: number;
}

export class BankAccount
{
    routingNumber: string;
    accountNumber: string;
    country: string;
    currency: string;
    accountHolderName: string;
    accountHolderType: string;
}

export class TaskDataOption
{
    text: string;
    value: string;
    hint: string;
}

export class TaskData
{
    name: string;
    label: string;
    type: string;
    mandatory: boolean;
    condition: string;
    options: TaskDataOption[];
}

export class WorkflowTaskDTO
{
    id: number;
    name: string;
    type: string;
    key: string;
    caseText: string;
    created: string;
    userId: number;
    text: string;
    scheduled: string;
    data: TaskData[];
}

export class OrderTaskDTO extends WorkflowTaskDTO
{
    orderId: number;
    supplierId: number;
    orderItemId: number;
    productId: number;
    productName: string;
}

export type TaxCodes = "STANDARD" | "REDUCED" | "REDUCEDALT" | "SUPERREDUCED" | "SUPERREDUCEDALT" | "PARKING" | "ZERO";

export interface IUserAuth
{
    id?: number;
    primaryEmail?: string;
    salt?: string;
    passwordHash?: string;
    digestHa1Hash?: string;
    roles?: string[];
    permissions?: string[];
    refId?: number;
    refIdStr?: string;
    invalidLoginAttempts?: number;
    lastLoginAttempt?: string;
    lockedDate?: string;
    createdDate?: string;
    modifiedDate?: string;
}

export interface IUserAuthDetails
{
    id?: number;
    userAuthId?: number;
    createdDate?: string;
    modifiedDate?: string;
    refId?: number;
    refIdStr?: string;
}

export type LoginTypes = "Login" | "Logout" | "Join" | "InvalidPassword" | "UnknownUser" | "AccountLocked";

export class UserAuthLogin
{
    id: number;
    userId: number;
    created: string;
    type: LoginTypes;
    // @StringLength(160)
    userAgent: string;

    // @StringLength(48)
    ip: string;

    // @StringLength(160)
    data: string;
}

export class VerticalDTO
{
    id: number;
    name: string;
    fullName: string;
    parentVerticalId: number;
    childCount: number;
}

export class GrapemarkPageResponse extends BaseResponse
{
}

export class TaxCode
{
    // @StringLength(30)
    id: string;

    // @StringLength(20)
    code: TaxCodes;

    // @StringLength(MaximumLength=60, MinimumLength=1)
    name: string;

    // @StringLength(MaximumLength=2, MinimumLength=2)
    country: string;

    // @StringLength(2)
    state: string;

    startDate: string;
    endDate: string;
    rate: number;
}

export class DeliveryTracker
{
    id: number;
    // @StringLength(40)
    name: string;

    // @StringLength(2)
    country: string;

    // @StringLength(40)
    idFormat: string;
}

export class PaymentMethodDTO
{
    id: number;
    name: string;
    userId: number;
    paymentType: PaymentTypes;
    cardType: string;
    last4: string;
    isDefault: boolean;
}

export class RecipientDTO
{
    id: number;
    name: string;
    userId: number;
    isDefault: boolean;
    fullName: string;
    address: Address;
    email: string;
    phone: string;
}

export class MyThingDTO
{
    id: number;
    created: string;
    modified: string;
    thingId: number;
    thingType: string;
    source: Source;
    orderId: number;
    orderDate: string;
    comment: string;
    thing: Object;
    tags: string[];
    when: string;
    ordering: number;
}

export interface IPopularityStatDTO
{
    summaryViewCount?: number;
    detailViewCount?: number;
    saveCount?: number;
    referralCount?: number;
    fastTrackCount?: number;
    summaryViewPercentage?: number;
    detailViewPercentage?: number;
    savePercentage?: number;
    referralPercentage?: number;
    fastTrackPercentage?: number;
    isUncategorised?: boolean;
}

export class DebugResponse extends BaseResponse
{
    request: DebugRequest;
}

// @Route("/api.v1/debug")
export class DebugRequest extends BaseRequest implements IReturn<DebugResponse>
{
    message: string;
    allLevels: boolean;
    throw: boolean;
    createResponse() { return new DebugResponse(); }
    getTypeName() { return "DebugRequest"; }
}

export class VideoTestResponse extends DigitalResponseBase<VideoTestResponse>
{
    message: string;
}

export class GetBrandConcessionContentResponse extends DigitalResponseBase<GetBrandConcessionContentResponse>
{
    brandConcession: BrandConcessionContentDTO;
}

export class GetProductSetContentResponse extends DigitalResponseBase<GetProductSetContentResponse>
{
    productSet: ProductSetContentDTO;
}

export class GetFeaturableBrandsResponse extends DigitalResponseBase<GetFeaturableBrandsResponse>
{
    brands: FeatureableBrandDTO[];
}

export class GetBrandFeaturesResponse extends DigitalResponseBase<GetBrandFeaturesResponse>
{
    brandFeatures: BrandFeaturesDTO;
}

export class GetBrandFeatureSectionTemplatesResponse extends DigitalResponseBase<GetBrandFeatureSectionTemplatesResponse>
{
    sectionTemplates: BrandFeatureSectionTemplateDTO[];
}

export class CreateBrandResponse extends DigitalResponseBase<CreateBrandResponse>
{
    brand: BrandFeaturesDTO;
}

export class GetBrandProductsResponse extends DigitalResponseBase<GetBrandProductsResponse>
{
    products: BrandFeatureProductDTO[];
}

export class UpdateBrandResponse extends DigitalResponseBase<UpdateBrandResponse>
{
    brand: BrandFeaturesDTO;
}

export class GetFloorsForBrandFeaturesResponse extends DigitalResponseBase<GetFloorsForBrandFeaturesResponse>
{
    floors: BrandFeatureFloorDTO[];
}

export class CreateBrandFeatureResponse extends DigitalResponseBase<CreateBrandFeatureResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureContentOptionsResponse extends DigitalResponseBase<UpdateBrandFeatureContentOptionsResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureTeaserProductsResponse extends DigitalResponseBase<UpdateBrandFeatureTeaserProductsResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureTitleResponse extends DigitalResponseBase<UpdateBrandFeatureTitleResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureSubTitleResponse extends DigitalResponseBase<UpdateBrandFeatureSubTitleResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureSummaryTextResponse extends DigitalResponseBase<UpdateBrandFeatureSummaryTextResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureMediaResponse extends DigitalResponseBase<UpdateBrandFeatureMediaResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureNavigationTextResponse extends DigitalResponseBase<UpdateBrandFeatureNavigationTextResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureHeaderBackgroundModeResponse extends DigitalResponseBase<UpdateBrandFeatureHeaderBackgroundModeResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureHeaderBackgroundColourResponse extends DigitalResponseBase<UpdateBrandFeatureHeaderBackgroundColourResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureHeaderFontColourResponse extends DigitalResponseBase<UpdateBrandFeatureHeaderFontColourResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureHeaderBackgroundMediaResponse extends DigitalResponseBase<UpdateBrandFeatureHeaderBackgroundMediaResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class UpdateBrandFeatureHiddenResponse extends DigitalResponseBase<UpdateBrandFeatureHiddenResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class DeleteBrandFeatureResponse extends DigitalResponseBase<DeleteBrandFeatureResponse>
{
    brandFeatures: BrandFeaturesDTO;
}

export class CreateBrandFeatureSectionResponse extends DigitalResponseBase<CreateBrandFeatureSectionResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionResponse extends DigitalResponseBase<UpdateBrandFeatureSectionResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionMediaResponse extends DigitalResponseBase<UpdateBrandFeatureSectionMediaResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionTitleResponse extends DigitalResponseBase<UpdateBrandFeatureSectionTitleResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionTextResponse extends DigitalResponseBase<UpdateBrandFeatureSectionTextResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionProductsResponse extends DigitalResponseBase<UpdateBrandFeatureSectionProductsResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionTemplateResponse extends DigitalResponseBase<UpdateBrandFeatureSectionTemplateResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionLinkUrlResponse extends DigitalResponseBase<UpdateBrandFeatureSectionLinkUrlResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionBackgroundModeResponse extends DigitalResponseBase<UpdateBrandFeatureSectionBackgroundModeResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionBackgroundColourResponse extends DigitalResponseBase<UpdateBrandFeatureSectionBackgroundColourResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionFontColourResponse extends DigitalResponseBase<UpdateBrandFeatureSectionFontColourResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionBackgroundMediaResponse extends DigitalResponseBase<UpdateBrandFeatureSectionBackgroundMediaResponse>
{
    featureSection: BrandFeatureSectionDTO;
}

export class UpdateBrandFeatureSectionSortOrderResponse extends DigitalResponseBase<UpdateBrandFeatureSectionSortOrderResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class DeleteBrandFeatureSectionResponse extends DigitalResponseBase<DeleteBrandFeatureSectionResponse>
{
    brandFeature: BrandFeatureDTO;
}

export class CreateProductSetResponse extends DigitalResponseBase<CreateProductSetResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class DeleteProductSetResponse extends DigitalResponseBase<DeleteProductSetResponse>
{
}

export class GetBrandsListResponse extends DigitalResponseBase<GetBrandsListResponse>
{
    brands: ProductBrandDTO[];
}

export class GetMagazineEditionsListResponse extends DigitalResponseBase<GetMagazineEditionsListResponse>
{
    editions: ContentManagerEditionDTO[];
}

export class GetProductSetResponse extends DigitalResponseBase<GetProductSetResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class GetProductSetFloorsResponse extends DigitalResponseBase<GetProductSetFloorsResponse>
{
    floors: ProductSetFloorDTO[];
}

export class GetProductSetsForFloorResponse extends DigitalResponseBase<GetProductSetsForFloorResponse>
{
    productSets: ProductSetIdentityDTO[];
}

export class GetProductsForBrandResponse extends DigitalResponseBase<GetProductsForBrandResponse>
{
    products: ProductSetFeatureProductDTO[];
}

export class GetProductsForMagazineEditionResponse extends DigitalResponseBase<GetProductsForMagazineEditionResponse>
{
    products: ProductSetFeatureProductDTO[];
}

export class UpdateProductSetResponse extends DigitalResponseBase<UpdateProductSetResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class UpdateProductSetHiddenResponse extends DigitalResponseBase<UpdateProductSetHiddenResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class UpdateProductSetImageResponse extends DigitalResponseBase<UpdateProductSetImageResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class UpdateProductSetProductsResponse extends DigitalResponseBase<UpdateProductSetProductsResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class UpdateProductSetSummaryTextResponse extends DigitalResponseBase<UpdateProductSetSummaryTextResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class UpdateProductSetTeaserProductsResponse extends DigitalResponseBase<UpdateProductSetTeaserProductsResponse>
{
    productSet: ProductSetFeatureDTO;
}

export class GetFloorsResponse extends DigitalResponseBase<GetFloorsResponse>
{
    floors: FloorDTO[];
}

export class GetFloorResponse extends DigitalResponseBase<GetFloorResponse>
{
    content: FloorContentDTO;
}

export class InitialiseResponse extends DigitalResponseBase<InitialiseResponse>
{
    serverTime: string;
}

export class GetTitlePublishersResponse extends DigitalResponseBase<GetTitlePublishersResponse>
{
    publishers: TitlePublisherDTO[];
}

export class CreateMagazineTitleResponse extends DigitalResponseBase<CreateMagazineTitleResponse>
{
    titleGroup: ContentManagerTitleGroupDTO;
}

export class CreateMagazineEditionResponse extends DigitalResponseBase<CreateMagazineEditionResponse>
{
    edition: ContentManagerEditionDTO;
}

export class CreateMagazinePageResponse extends DigitalResponseBase<CreateMagazinePageResponse>
{
    page: ContentManagerPageDTO;
}

export class GetMagazineTitlesResponse extends DigitalResponseBase<GetMagazineTitlesResponse>
{
    titleGroups: ContentManagerTitleGroupDTO[];
}

export class GetMagazineEditionsResponse extends DigitalResponseBase<GetMagazineEditionsResponse>
{
    editions: ContentManagerEditionDTO[];
}

export class GetEditionContentByPageResponse extends DigitalResponseBase<GetEditionContentByPageResponse>
{
    pages: ContentManagerPageDTO[];
}

export class CaptureOrderFundsResponse extends DigitalResponseBase<CaptureOrderFundsResponse>
{
    amountCaptured: number;
}

export class GetUserOrderHistoryResponse extends DigitalResponseBase<GetUserOrderHistoryResponse>
{
    orders: HistoryOrderDTO[];
}

export class CancelOrderResponse extends DigitalResponseBase<CancelOrderResponse>
{
    order: HistoryOrderDTO;
    message: string;
}

export class SendOrderMessageResponse extends DigitalResponseBase<SendOrderMessageResponse>
{
}

export class GetUserOrderSummaryResponse extends DigitalResponseBase<GetUserOrderSummaryResponse>
{
    orderSummary: UserOrderSummaryDTO;
}

export class ConfirmUserOrderResponse extends DigitalResponseBase<ConfirmUserOrderResponse>
{
    status: ConfirmUserOrderStatus;
    userMessage: string;
    clientSecret: string;
    orderToken: string;
    orderConfirmation: UserOrderConfirmationDTO;
}

export class ReconfirmUserOrderResponse extends DigitalResponseBase<ReconfirmUserOrderResponse>
{
    status: ConfirmUserOrderStatus;
    userMessage: string;
    clientSecret: string;
    orderToken: string;
    orderConfirmation: UserOrderConfirmationDTO;
}

export class AuthenticateUserOrderResponse extends DigitalResponseBase<AuthenticateUserOrderResponse>
{
    status: ConfirmUserOrderStatus;
    userMessage: string;
    clientSecret: string;
    orderConfirmation: UserOrderConfirmationDTO;
}

export class GetProduct2Response extends DigitalResponseBase<GetProduct2Response>
{
    product: ProductDefinitionDTO;
}

export class CreateProduct2Response extends DigitalResponseBase<CreateProduct2Response>
{
    product: ProductDefinitionDTO;
}

export class UpdateProduct2Response extends DigitalResponseBase<UpdateProduct2Response>
{
    product: ProductDefinitionDTO;
}

export class GetAllProductPrimaryActionsResponse extends DigitalResponseBase<GetAllProductPrimaryActionsResponse>
{
    productPrimaryActions: ProductPrimaryActionDTO[];
}

export class GetAllProductBrandsResponse extends DigitalResponseBase<GetAllProductBrandsResponse>
{
    productBrands: ProductBrandDTO[];
}

export class SearchBrandsResponse extends DigitalResponseBase<SearchBrandsResponse>
{
    matchingBrands: ProductBrandDTO[];
}

export class GetAllProductCategoriesResponse extends DigitalResponseBase<GetAllProductCategoriesResponse>
{
    productCategories: ProductCategoryDTO[];
}

export class GetProductDetailForEditResponse extends DigitalResponseBase<GetProductDetailForEditResponse>
{
    product: ProductDetailForEditDTO;
}

export class GetProductDetailResponse extends DigitalResponseBase<GetProductDetailResponse>
{
    productDetail: ProductDetailsDTO;
}

export class ShareProductResponse
{
    success: boolean;
    valid: boolean;
    message: string;
}

export class SignupResponse extends DigitalResponseBase<SignupResponse>
{
    exists: boolean;
}

export class SignupFromOrderResponse extends DigitalResponseBase<SignupFromOrderResponse>
{
}

export class CreateNewUserResponse extends DigitalResponseBase<CreateNewUserResponse>
{
    userDetail: UserDetailDTO;
}

export class GetUserListResponse extends DigitalResponseBase<GetUserListResponse>
{
    users: UserSummaryDTO[];
}

export class GetUserDetailResponse extends DigitalResponseBase<GetUserDetailResponse>
{
    userDetail: UserDetailDTO;
}

export class GetUserEventsResponse extends DigitalResponseBase<GetUserEventsResponse>
{
    response: Object;
}

export class SetUserDetailResponse extends DigitalResponseBase<SetUserDetailResponse>
{
    userDetail: UserDetailDTO;
}

export class GetRolesListResponse extends DigitalResponseBase<GetRolesListResponse>
{
    roles: UserRoleDefinitionDTO[];
}

export class GetRoleOptionsListResponse extends DigitalResponseBase<GetRoleOptionsListResponse>
{
    parameterOptions: RoleParameterOptionDTO[];
}

export class AddUserRoleResponse extends DigitalResponseBase<AddUserRoleResponse>
{
    userDetail: UserDetailDTO;
}

export class RemoveUserRoleResponse extends DigitalResponseBase<RemoveUserRoleResponse>
{
    userDetail: UserDetailDTO;
}

export class GenerateUserPasswordResponse extends DigitalResponseBase<GenerateUserPasswordResponse>
{
    password: string;
}

export class UpdateUserPasswordResponse extends DigitalResponseBase<UpdateUserPasswordResponse>
{
}

export class RequestUserPasswordResetResponse extends DigitalResponseBase<RequestUserPasswordResetResponse>
{
    passwordResetEmailSentTo: string;
}

export class GetUserListsResponse extends DigitalResponseBase<GetUserListsResponse>
{
    contextProductId: number;
    userLists: UserListDTO[];
}

export class AddUserListResponse extends DigitalResponseBase<AddUserListResponse>
{
    contextProductId: number;
    userList: UserListDTO;
    userLists: UserListDTO[];
}

export class AddProductToUserListResponse extends DigitalResponseBase<AddProductToUserListResponse>
{
    contextProductId: number;
    userList: UserListDTO;
    userLists: UserListDTO[];
}

export class RemoveProductFromUserListResponse extends DigitalResponseBase<RemoveProductFromUserListResponse>
{
    contextProductId: number;
    userList: UserListDTO;
    userLists: UserListDTO[];
}

export class RequestPasswordResetResponse extends DigitalResponseBase<RequestPasswordResetResponse>
{
    message: string;
}

export class AcceptPasswordResetResponse extends DigitalResponseBase<AcceptPasswordResetResponse>
{
    passwordChanged: boolean;
    userShouldRetry: boolean;
    message: string;
}

export class GetUserPreferencesResponse extends DigitalResponseBase<GetUserPreferencesResponse>
{
    preferences: UserPreferencesDTO;
}

export class SetUserSmartBrowsingResponse extends DigitalResponseBase<SetUserSmartBrowsingResponse>
{
    smartBrowsingActive: boolean;
    smartBrowsingDeactivationWarning: boolean;
}

export class AddSavedAddressResponse extends DigitalResponseBase<AddSavedAddressResponse>
{
    newAddressId: number;
    savedAddresses: SavedAddressDTO[];
}

export class RemoveSavedAddressResponse extends DigitalResponseBase<RemoveSavedAddressResponse>
{
    savedAddresses: SavedAddressDTO[];
}

export class UpdateSavedAddressResponse extends DigitalResponseBase<UpdateSavedAddressResponse>
{
    savedAddresses: SavedAddressDTO[];
}

export class SetDefaultSavedAddressResponse extends DigitalResponseBase<SetDefaultSavedAddressResponse>
{
    savedAddresses: SavedAddressDTO[];
}

export class AddSavedCardResponse extends DigitalResponseBase<AddSavedCardResponse>
{
    newCardId: number;
    savedCards: SavedCardDTO[];
}

export class RemoveSavedCardResponse extends DigitalResponseBase<RemoveSavedCardResponse>
{
    savedCards: SavedCardDTO[];
}

export class SetDefaultSavedCardResponse extends DigitalResponseBase<SetDefaultSavedCardResponse>
{
    savedCards: SavedCardDTO[];
}

export class GetUserSettingsResponse extends DigitalResponseBase<GetUserSettingsResponse>
{
    fullName: string;
    email: string;
    privacyConsent: boolean;
    savedAddresses: SavedAddressDTO[];
    savedCards: SavedCardDTO[];
}

export class SetUserDetailsResponse extends DigitalResponseBase<SetUserDetailsResponse>
{
    fullName: string;
}

export class SetUserPasswordResponse extends DigitalResponseBase<SetUserPasswordResponse>
{
}

export class SetUserPrivacyConsentResponse extends DigitalResponseBase<SetUserPrivacyConsentResponse>
{
    privacyConsent: boolean;
}

export class GetUserSettingsTokenResponse extends DigitalResponseBase<GetUserSettingsTokenResponse>
{
    token: string;
    expires: string;
}

export class ValidateUserSettingsTokenResponse extends DigitalResponseBase<ValidateUserSettingsTokenResponse>
{
    valid: boolean;
}

export class SendSupportMessageResponse extends DigitalResponseBase<SendSupportMessageResponse>
{
}

export class GetFloorPlanResponse extends DigitalResponseBase<GetFloorPlanResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class AddFloorRegionResponse extends DigitalResponseBase<AddFloorRegionResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class ClearFloorRegionResponse extends DigitalResponseBase<ClearFloorRegionResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class MoveFloorRegionResponse extends DigitalResponseBase<MoveFloorRegionResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class AddFloorHorizontalPathwayResponse extends DigitalResponseBase<AddFloorHorizontalPathwayResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class RemoveFloorHorizontalPathwayResponse extends DigitalResponseBase<RemoveFloorHorizontalPathwayResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class AddFloorVerticalPathwayResponse extends DigitalResponseBase<AddFloorVerticalPathwayResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class RemoveFloorVerticalPathwayResponse extends DigitalResponseBase<RemoveFloorVerticalPathwayResponse>
{
    floorPlan: VisualiserFloorPlanDTO;
}

export class GetFloorDepartmentPlanResponse extends DigitalResponseBase<GetFloorDepartmentPlanResponse>
{
    departmentPlan: VisualiserDepartmentPlanDTO;
}

export class AddFloorDisplayResponse extends DigitalResponseBase<AddFloorDisplayResponse>
{
    departmentPlan: VisualiserDepartmentPlanDTO;
}

export class ClearFloorDisplayResponse extends DigitalResponseBase<ClearFloorDisplayResponse>
{
    departmentPlan: VisualiserDepartmentPlanDTO;
}

export class MoveFloorDisplayResponse extends DigitalResponseBase<MoveFloorDisplayResponse>
{
    departmentPlan: VisualiserDepartmentPlanDTO;
}

export class SetFloorDepartmentFocusPointResponse extends DigitalResponseBase<SetFloorDepartmentFocusPointResponse>
{
    departmentPlan: VisualiserDepartmentPlanDTO;
}

export class SetFloorDisplayGutterStyleResponse extends DigitalResponseBase<SetFloorDisplayGutterStyleResponse>
{
    departmentPlan: VisualiserDepartmentPlanDTO;
}

export class AddVisualiserDepartmentResponse extends DigitalResponseBase<AddVisualiserDepartmentResponse>
{
    department: VisualiserDepartmentDTO;
}

export class AddVisualiserFloorResponse extends DigitalResponseBase<AddVisualiserFloorResponse>
{
    floor: VisualiserFloorDTO;
}

export class DeleteVisualiserDepartmentResponse extends DigitalResponseBase<DeleteVisualiserDepartmentResponse>
{
}

export class DeleteVisualiserFloorResponse extends DigitalResponseBase<DeleteVisualiserFloorResponse>
{
    floors: VisualiserFloorDTO[];
}

export class GetVisualiserDepartmentMergeCandidatesResponse extends DigitalResponseBase<GetVisualiserDepartmentMergeCandidatesResponse>
{
    departments: OwnableDepartmentDTO[];
}

export class GetVisualiserDepartmentsResponse extends DigitalResponseBase<GetVisualiserDepartmentsResponse>
{
    departments: VisualiserDepartmentDTO[];
}

export class GetVisualiserDisplaysResponse extends DigitalResponseBase<GetVisualiserDisplaysResponse>
{
    displays: VisualiserDisplayDTO[];
}

export class GetVisualiserPendingDisplaysResponse extends DigitalResponseBase<GetVisualiserPendingDisplaysResponse>
{
    displays: VisualiserDisplayDTO[];
}

export class MoveVisualiserDisplayResponse extends DigitalResponseBase<MoveVisualiserDisplayResponse>
{
    display: VisualiserDisplayDTO;
}

export class GetVisualiserFloorsResponse extends DigitalResponseBase<GetVisualiserFloorsResponse>
{
    floors: VisualiserFloorDTO[];
}

export class MergeVisualiserDepartmentsResponse extends DigitalResponseBase<MergeVisualiserDepartmentsResponse>
{
    destinationDepartment: VisualiserDepartmentDTO;
}

export class MoveVisualiserDepartmentResponse extends DigitalResponseBase<MoveVisualiserDepartmentResponse>
{
    department: VisualiserDepartmentDTO;
}

export class SetVisualiserFloorAsDefaultResponse extends DigitalResponseBase<SetVisualiserFloorAsDefaultResponse>
{
    floors: VisualiserFloorDTO[];
}

export class SetVisualiserFloorsOrderResponse extends DigitalResponseBase<SetVisualiserFloorsOrderResponse>
{
    floors: VisualiserFloorDTO[];
}

export class UpdateVisualiserDepartmentResponse extends DigitalResponseBase<UpdateVisualiserDepartmentResponse>
{
    department: VisualiserDepartmentDTO;
}

export class UpdateVisualiserFloorResponse extends DigitalResponseBase<UpdateVisualiserFloorResponse>
{
    floors: VisualiserFloorDTO[];
}

export class GetEditionProductSummaryStatsResponse extends BaseResponse
{
    websiteId: number;
    productBrands: BreakdownCategoryDTO[];
    productTypes: BreakdownCategoryDTO[];
    productSuppliers: BreakdownCategoryDTO[];
    productSupplierTypes: BreakdownCategoryDTO[];
    productPriceBands: BreakdownCategoryDTO[];
    productRetailValueStats: EditionProductRetailValueStatsDTO;
    referralEventRetailValueStats: EditionReferralEventRetailValueStatsDTO;
}

export class GetWebsiteEventSummaryStatsResponse extends BaseResponse
{
    websiteId: number;
    monthSummaries: WebsiteSummaryStatsDTO[];
}

export class CreateLogEventResponse extends BaseResponse
{
    event: LogEvent;
}

export class GetOrdersResponse extends PagingResponse
{
    orders: OrderDTO[];
}

export class GetPublisherOrdersResponse extends PagingResponse
{
    orders: PublisherOrderItemWithOrderDTO[];
}

export class GetUserOrdersResponse extends PagingResponse
{
    orders: UserOrderDTO[];
}

export class GetOrderResponse extends BaseResponse
{
    order: OrderDTO;
    history: OrderHistoryDTO[];
}

export class DeleteOrderResponse extends BaseResponse
{
}

export class GetOrderHistoryResponse extends BaseResponse
{
    history: OrderHistoryDTO[];
}

export class GetPurchaseSuppliersResponse extends BaseResponse
{
    total: number;
    start: number;
    suppliers: SupplierDTO[];
}

export class GetPurchaseSourcesResponse extends BaseResponse
{
    total: number;
    start: number;
    sources: Source[];
}

export class GetCurrentUserOrdersResponse extends BaseResponse
{
    total: number;
    start: number;
    orders: UserOrderDTO[];
}

export class GetCurrentUserOrderResponse extends BaseResponse
{
    order: UserOrderDTO;
}

export class SendMessagePurchaseResponse extends BaseResponse
{
    order: OrderDTO;
}

export class SupplierSendMessageResponse extends BaseResponse
{
    order: OrderDTO;
    tickets: TicketDTO[];
}

export class SupplierRejectOrderResponse extends BaseResponse
{
    order: SupplierOrderDTO;
    ledger: LedgerDTO[];
    history: OrderHistoryDTO[];
}

export class AcceptBidResponse extends BaseResponse
{
    order: Object;
}

export class SupplierUpdateOrderResponse extends BaseResponse
{
    order: SupplierOrderDTO;
    ledger: LedgerDTO[];
    history: OrderHistoryDTO[];
}

export class SupplierRefundOrderResponse extends BaseResponse
{
    order: SupplierOrderDTO;
}

export class AcceptReferralResponse
{
}

export class AcceptAlternateReferralResponse
{
}

export class GetPublisherEditionSummariesResponse
{
    editionSummaries: EditionSummaryDTO[];
}

export class GetProductPopularityStatsResponse extends BaseResponse
{
    products: ProductPopularityDTO[];
}

export class GetProductBrandPopularityStatsResponse extends BaseResponse
{
    brands: ProductBrandPopularityDTO[];
}

export class GetProductTypePopularityStatsResponse extends BaseResponse
{
    productTypes: ProductTypePopularityDTO[];
}

export class GetProductSupplierPopularityStatsResponse
{
    suppliers: ProductSupplierPopularityDTO[];
}

export class GetPublisherAffiliateRevenueStatsResponse extends BaseResponse
{
    affiliateRevenueItems: PublisherAffiliateRevenueStatsDTO[];
}

export class GetGroupEventSummaryStatsResponse extends BaseResponse
{
    publisherGroupId: number;
    editionSummaries: EditionSummaryStatsDTO[];
}

export class GetReferralsResponse extends PagingResponse
{
    referrals: ReferralDTO[];
}

export class GetReferralResponse extends BaseResponse
{
    referral: ReferralDTO;
}

export class CreateReferralResponse extends GetReferralResponse
{
}

export class UpdateReferralResponse extends GetReferralResponse
{
}

export class DeleteReferralResponse extends BaseResponse
{
}

export class GetSharedProductResponse extends BaseResponse
{
    id: number;
    name: string;
    brand: string;
    price: string;
    mediaUrl: string;
    actionUrl: string;
}

export class GetSupplierBidsResponse extends PagingResponse
{
    bids: OrderBidDTO[];
}

export class CreateSupplierBidResponse extends BaseResponse
{
    bid: OrderBidDTO;
}

export class UpdateSupplierBidResponse extends BaseResponse
{
    bid: OrderBidDTO;
}

export class DeleteSupplierBidResponse extends BaseResponse
{
}

export class GetSuppliersBrandsResponse extends PagingResponse
{
    brands: string[];
}

export class GetSupplierBrandsResponse extends PagingResponse
{
    brands: string[];
}

export class UpdateSupplierBrandResponse extends BaseResponse
{
}

export class GetSupplierDistributorsResponse extends PagingResponse
{
    distributors: SupplierDistributorDTO[];
}

export class GetSupplierDistributorResponse extends BaseResponse
{
    distributor: SupplierDTO;
}

export class CreateSupplierDistributorResponse extends BaseResponse
{
}

export class UpdateSupplierDistributorResponse extends BaseResponse
{
    distributor: SupplierDistributorDTO;
}

export class DeleteSupplierDistributorResponse extends BaseResponse
{
}

export class GetSupplierLedgerPayeesResponse extends PagingResponse
{
    payees: Owed[];
}

export class GetSupplierLedgerResponse extends PagingResponse
{
    ledger: LedgerDTO[];
}

export class CreateSupplierLedgerResponse extends BaseResponse
{
}

export class GetAvailableOrdersResponse extends PagingResponse
{
    orders: AvailableOrderDTO[];
}

export class GetSupplierOrdersResponse extends PagingResponse
{
    orders: SupplierOrderDTO[];
}

export class GetSupplierOrderResponse extends PagingResponse
{
    order: SupplierOrderDTO;
    history: OrderHistoryDTO[];
    ledger: LedgerDTO[];
    tickets: TicketDTO[];
}

export class GetSupplierOrdersUsersResponse extends PagingResponse
{
    users: PublicUserDTO[];
}

export class GetSupplierPublishersResponse extends PagingResponse
{
    publishers: PublisherSupplierDTO[];
}

export class GetSupplierPublisherResponse extends BaseResponse
{
    publisher: PublisherDTO;
}

export class CreateSupplierPublisherResponse extends BaseResponse
{
}

export class UpdateSupplierPublisherResponse extends BaseResponse
{
    publisher: PublisherSupplierDTO;
}

export class DeleteSupplierPublisherResponse extends BaseResponse
{
}

export class GetSuppliersResponse extends PagingResponse
{
    suppliers: SupplierDTO[];
}

export class GetUserSuppliersResponse extends PagingResponse
{
    suppliers: SupplierDTO[];
}

export class GetSupplierResponse extends BaseResponse
{
    supplier: SupplierDTO;
}

export class GetPreferredSuppliersResponse extends BaseResponse
{
    preferredSuppliers: SupplierDTO[];
}

export class CreateSupplierResponse extends BaseResponse
{
    supplier: SupplierDTO;
}

export class UpdateSupplierResponse extends BaseResponse
{
    supplier: SupplierDTO;
}

export class DeleteSupplierResponse extends BaseResponse
{
}

export class VerifySupplierEmailResponse extends BaseResponse
{
}

export class GetSupplierAffiliateSchemesResponse extends BaseResponse
{
    supplierId: number;
    affiliateSchemes: AffiliateSchemeDTO[];
}

export class GetSupplierTypesResponse extends BaseResponse
{
    supplierTypes: SupplierTypeDTO[];
}

export class StripeAuthorisationResponse extends BaseResponse
{
}

export class StripeDeauthoriseResponse extends BaseResponse
{
    supplier: SupplierDTO;
}

export class SupplierCreateManagedStripeResponse extends BaseResponse
{
    supplier: SupplierDTO;
}

export class GetSupplierTasksResponse extends PagingResponse
{
    tasks: OrderTaskDTO[];
}

export class GetSupplierTaskResponse extends BaseResponse
{
    task: OrderTaskDTO;
}

export class SupplierTaxRateResponse extends BaseResponse
{
    rate: number;
}

export class GetUsersResponse extends PagingResponse
{
    users: UserDTO[];
}

export class GetSupplierUsersResponse extends GetUsersResponse
{
}

export class GetUserResponse extends BaseResponse
{
    user: IUserAuth;
    auths: IUserAuthDetails[];
    logins: UserAuthLogin[];
}

export class GetSupplierUserResponse extends GetUserResponse
{
}

export class GetVerticalsResponse extends BaseResponse
{
    verticals: VerticalDTO[];
}

export class GetSupplierVerticalsResponse extends BaseResponse
{
    verticals: VerticalDTO[];
}

export class CreateSupplierVerticalResponse extends BaseResponse
{
}

export class RootResponse extends BaseResponse
{
    layout: string;
}

export class StatusResponse extends BaseResponse
{
}

export class RedirectResponse extends BaseResponse
{
}

export class GetCurrentUserResponse extends BaseResponse
{
    user: UserDTO;
}

// @DataContract
export class AuthenticateResponse
{
    // @DataMember(Order=1)
    userId: string;

    // @DataMember(Order=2)
    sessionId: string;

    // @DataMember(Order=3)
    userName: string;

    // @DataMember(Order=4)
    displayName: string;

    // @DataMember(Order=5)
    referrerUrl: string;

    // @DataMember(Order=6)
    bearerToken: string;

    // @DataMember(Order=7)
    refreshToken: string;

    // @DataMember(Order=8)
    responseStatus: ResponseStatus;

    // @DataMember(Order=9)
    meta: { [index:string]: string; };
}

export class EmailVerificationResponse extends GrapemarkPageResponse
{
    verified: boolean;
    invalid: boolean;
    expired: boolean;
}

export class HomeResponse extends BaseResponse
{
    user: IUserAuth;
}

export class AdminHomeResponse extends BaseResponse
{
    header: boolean;
    sidebar: boolean;
    footer: boolean;
    user: UserDTO;
    supplierIds: number[];
    publisherIds: number[];
}

export class PostRegisterResponse extends BaseResponse
{
    user: UserDTO;
}

export class CheckExistingUserResponse extends BaseResponse
{
    exists: boolean;
}

export class CheckCommonPasswordResponse extends BaseResponse
{
    exists: boolean;
}

export class GetTaxCodesResponse extends BaseResponse
{
    taxCodes: TaxCode[];
}

export class GetDeliveryTrackersResponse extends BaseResponse
{
    trackers: DeliveryTracker[];
}

export class GetPaymentMethodsResponse extends PagingResponse
{
    paymentMethods: PaymentMethodDTO[];
}

export class GetPaymentMethodResponse extends BaseResponse
{
    paymentMethod: PaymentMethodDTO;
}

export class AddPaymentMethodResponse extends BaseResponse
{
    paymentMethod: PaymentMethodDTO;
}

export class UpdatePaymentMethodResponse
{
    paymentMethod: PaymentMethodDTO;
}

export class DeletePaymentMethodResponse
{
}

export class GetRecipientsResponse extends PagingResponse
{
    recipients: RecipientDTO[];
}

export class GetRecipientResponse extends BaseResponse
{
    recipient: RecipientDTO;
}

export class AddRecipientResponse
{
    recipient: RecipientDTO;
}

export class UpdateRecipientResponse
{
    recipient: RecipientDTO;
}

export class DeleteRecipientResponse
{
}

export class GetRolesResponse
{
    roles: string[];
}

export class UserSharedResponse extends BaseResponse
{
    myThings: MyThingDTO[];
    user: IUserAuth;
    sharedBy: IUserAuth;
}

export class GetWebsiteSuppliersResponse extends PagingResponse
{
    suppliers: SupplierDTO[];
}

export class CreateWebsiteSupplierResponse extends BaseResponse
{
    supplier: SupplierDTO;
}

export class DeleteWebsiteSupplierResponse extends BaseResponse
{
}

export class SetOrderDeliveredResponse extends BaseResponse
{
}

export class SetOrderReturnRequestedResponse extends BaseResponse
{
}

export class SetOrderRefundedResponse extends BaseResponse
{
}

export class SendOrderCustomerMessageResponse
{
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    allRoles: string[];

    // @DataMember(Order=2)
    allPermissions: string[];

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    allRoles: string[];

    // @DataMember(Order=2)
    allPermissions: string[];

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @DataContract
export class ConvertSessionToTokenResponse
{
    // @DataMember(Order=1)
    meta: { [index:string]: string; };

    // @DataMember(Order=2)
    accessToken: string;

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @DataContract
export class GetAccessTokenResponse
{
    // @DataMember(Order=1)
    accessToken: string;

    // @DataMember(Order=2)
    responseStatus: ResponseStatus;
}

export class VideoTest implements IReturn<VideoTestResponse>
{
    videoBase64: string;
    contentType: string;
    createResponse() { return new VideoTestResponse(); }
    getTypeName() { return "VideoTest"; }
}

export class GetBrandConcessionContent implements IReturn<GetBrandConcessionContentResponse>
{
    brandConcessionId: number;
    createResponse() { return new GetBrandConcessionContentResponse(); }
    getTypeName() { return "GetBrandConcessionContent"; }
}

export class GetProductSetContent implements IReturn<GetProductSetContentResponse>
{
    productSetId: number;
    createResponse() { return new GetProductSetContentResponse(); }
    getTypeName() { return "GetProductSetContent"; }
}

export class GetFeaturableBrands implements IReturn<GetFeaturableBrandsResponse>
{
    createResponse() { return new GetFeaturableBrandsResponse(); }
    getTypeName() { return "GetFeaturableBrands"; }
}

export class GetBrandFeatures implements IReturn<GetBrandFeaturesResponse>
{
    brandId: number;
    createResponse() { return new GetBrandFeaturesResponse(); }
    getTypeName() { return "GetBrandFeatures"; }
}

export class GetBrandFeatureSectionTemplates implements IReturn<GetBrandFeatureSectionTemplatesResponse>
{
    createResponse() { return new GetBrandFeatureSectionTemplatesResponse(); }
    getTypeName() { return "GetBrandFeatureSectionTemplates"; }
}

export class CreateBrand implements IReturn<CreateBrandResponse>
{
    brandName: string;
    createResponse() { return new CreateBrandResponse(); }
    getTypeName() { return "CreateBrand"; }
}

export class GetBrandProducts implements IReturn<GetBrandProductsResponse>
{
    brandId: number;
    maxAgeDays: number;
    published: boolean;
    createResponse() { return new GetBrandProductsResponse(); }
    getTypeName() { return "GetBrandProducts"; }
}

export class UpdateBrand implements IReturn<UpdateBrandResponse>
{
    brandId: number;
    brandImageBase64: string;
    brandImageContentType: string;
    aboutBrand: string;
    hidden: boolean;
    changeImage: boolean;
    createResponse() { return new UpdateBrandResponse(); }
    getTypeName() { return "UpdateBrand"; }
}

export class GetFloorsForBrandFeatures implements IReturn<GetFloorsForBrandFeaturesResponse>
{
    createResponse() { return new GetFloorsForBrandFeaturesResponse(); }
    getTypeName() { return "GetFloorsForBrandFeatures"; }
}

export class CreateBrandFeature implements IReturn<CreateBrandFeatureResponse>
{
    brandId: number;
    floorId: number;
    createResponse() { return new CreateBrandFeatureResponse(); }
    getTypeName() { return "CreateBrandFeature"; }
}

export class UpdateBrandFeatureContentOptions implements IReturn<UpdateBrandFeatureContentOptionsResponse>
{
    brandFeatureId: number;
    showHeroMediaInHeader: boolean;
    createResponse() { return new UpdateBrandFeatureContentOptionsResponse(); }
    getTypeName() { return "UpdateBrandFeatureContentOptions"; }
}

export class UpdateBrandFeatureTeaserProducts implements IReturn<UpdateBrandFeatureTeaserProductsResponse>
{
    brandFeatureId: number;
    teaserProductIds: number[];
    createResponse() { return new UpdateBrandFeatureTeaserProductsResponse(); }
    getTypeName() { return "UpdateBrandFeatureTeaserProducts"; }
}

export class UpdateBrandFeatureTitle implements IReturn<UpdateBrandFeatureTitleResponse>
{
    brandFeatureId: number;
    title: string;
    createResponse() { return new UpdateBrandFeatureTitleResponse(); }
    getTypeName() { return "UpdateBrandFeatureTitle"; }
}

export class UpdateBrandFeatureSubTitle implements IReturn<UpdateBrandFeatureSubTitleResponse>
{
    brandFeatureId: number;
    subTitle: string;
    createResponse() { return new UpdateBrandFeatureSubTitleResponse(); }
    getTypeName() { return "UpdateBrandFeatureSubTitle"; }
}

export class UpdateBrandFeatureSummaryText implements IReturn<UpdateBrandFeatureSummaryTextResponse>
{
    brandFeatureId: number;
    summaryText: string;
    createResponse() { return new UpdateBrandFeatureSummaryTextResponse(); }
    getTypeName() { return "UpdateBrandFeatureSummaryText"; }
}

export class UpdateBrandFeatureMedia implements IReturn<UpdateBrandFeatureMediaResponse>
{
    brandFeatureId: number;
    mediaBase64: string;
    mediaContentType: string;
    createResponse() { return new UpdateBrandFeatureMediaResponse(); }
    getTypeName() { return "UpdateBrandFeatureMedia"; }
}

export class UpdateBrandFeatureNavigationText implements IReturn<UpdateBrandFeatureNavigationTextResponse>
{
    brandFeatureId: number;
    navigationTextTemplate: string;
    createResponse() { return new UpdateBrandFeatureNavigationTextResponse(); }
    getTypeName() { return "UpdateBrandFeatureNavigationText"; }
}

export class UpdateBrandFeatureHeaderBackgroundMode implements IReturn<UpdateBrandFeatureHeaderBackgroundModeResponse>
{
    brandFeatureId: number;
    backgroundMode: BrandConcessionBackgroundMode;
    createResponse() { return new UpdateBrandFeatureHeaderBackgroundModeResponse(); }
    getTypeName() { return "UpdateBrandFeatureHeaderBackgroundMode"; }
}

export class UpdateBrandFeatureHeaderBackgroundColour implements IReturn<UpdateBrandFeatureHeaderBackgroundColourResponse>
{
    brandFeatureId: number;
    backgroundColourHex: string;
    createResponse() { return new UpdateBrandFeatureHeaderBackgroundColourResponse(); }
    getTypeName() { return "UpdateBrandFeatureHeaderBackgroundColour"; }
}

export class UpdateBrandFeatureHeaderFontColour implements IReturn<UpdateBrandFeatureHeaderFontColourResponse>
{
    brandFeatureId: number;
    fontColourHex: string;
    createResponse() { return new UpdateBrandFeatureHeaderFontColourResponse(); }
    getTypeName() { return "UpdateBrandFeatureHeaderFontColour"; }
}

export class UpdateBrandFeatureHeaderBackgroundMedia implements IReturn<UpdateBrandFeatureHeaderBackgroundMediaResponse>
{
    brandFeatureId: number;
    mediaBase64: string;
    mediaContentType: string;
    createResponse() { return new UpdateBrandFeatureHeaderBackgroundMediaResponse(); }
    getTypeName() { return "UpdateBrandFeatureHeaderBackgroundMedia"; }
}

export class UpdateBrandFeatureHidden implements IReturn<UpdateBrandFeatureHiddenResponse>
{
    brandFeatureId: number;
    hidden: boolean;
    createResponse() { return new UpdateBrandFeatureHiddenResponse(); }
    getTypeName() { return "UpdateBrandFeatureHidden"; }
}

export class DeleteBrandFeature implements IReturn<DeleteBrandFeatureResponse>
{
    brandFeatureId: number;
    createResponse() { return new DeleteBrandFeatureResponse(); }
    getTypeName() { return "DeleteBrandFeature"; }
}

export class CreateBrandFeatureSection implements IReturn<CreateBrandFeatureSectionResponse>
{
    brandFeatureId: number;
    createResponse() { return new CreateBrandFeatureSectionResponse(); }
    getTypeName() { return "CreateBrandFeatureSection"; }
}

export class UpdateBrandFeatureSection implements IReturn<UpdateBrandFeatureSectionResponse>
{
    featureSectionId: number;
    name: string;
    createResponse() { return new UpdateBrandFeatureSectionResponse(); }
    getTypeName() { return "UpdateBrandFeatureSection"; }
}

export class UpdateBrandFeatureSectionMedia implements IReturn<UpdateBrandFeatureSectionMediaResponse>
{
    featureSectionId: number;
    mediaBase64: string;
    mediaContentType: string;
    createResponse() { return new UpdateBrandFeatureSectionMediaResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionMedia"; }
}

export class UpdateBrandFeatureSectionTitle implements IReturn<UpdateBrandFeatureSectionTitleResponse>
{
    featureSectionId: number;
    title: string;
    createResponse() { return new UpdateBrandFeatureSectionTitleResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionTitle"; }
}

export class UpdateBrandFeatureSectionText implements IReturn<UpdateBrandFeatureSectionTextResponse>
{
    featureSectionId: number;
    summaryText: string;
    createResponse() { return new UpdateBrandFeatureSectionTextResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionText"; }
}

export class UpdateBrandFeatureSectionProducts implements IReturn<UpdateBrandFeatureSectionProductsResponse>
{
    featureSectionId: number;
    productIds: number[];
    createResponse() { return new UpdateBrandFeatureSectionProductsResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionProducts"; }
}

export class UpdateBrandFeatureSectionTemplate implements IReturn<UpdateBrandFeatureSectionTemplateResponse>
{
    featureSectionId: number;
    sectionTemplateId: number;
    createResponse() { return new UpdateBrandFeatureSectionTemplateResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionTemplate"; }
}

export class UpdateBrandFeatureSectionLinkUrl implements IReturn<UpdateBrandFeatureSectionLinkUrlResponse>
{
    featureSectionId: number;
    linkUrl: string;
    createResponse() { return new UpdateBrandFeatureSectionLinkUrlResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionLinkUrl"; }
}

export class UpdateBrandFeatureSectionBackgroundMode implements IReturn<UpdateBrandFeatureSectionBackgroundModeResponse>
{
    featureSectionId: number;
    backgroundMode: BrandConcessionBackgroundMode;
    createResponse() { return new UpdateBrandFeatureSectionBackgroundModeResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionBackgroundMode"; }
}

export class UpdateBrandFeatureSectionBackgroundColour implements IReturn<UpdateBrandFeatureSectionBackgroundColourResponse>
{
    featureSectionId: number;
    backgroundColourHex: string;
    createResponse() { return new UpdateBrandFeatureSectionBackgroundColourResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionBackgroundColour"; }
}

export class UpdateBrandFeatureSectionFontColour implements IReturn<UpdateBrandFeatureSectionFontColourResponse>
{
    featureSectionId: number;
    fontColourHex: string;
    createResponse() { return new UpdateBrandFeatureSectionFontColourResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionFontColour"; }
}

export class UpdateBrandFeatureSectionBackgroundMedia implements IReturn<UpdateBrandFeatureSectionBackgroundMediaResponse>
{
    featureSectionId: number;
    mediaBase64: string;
    mediaContentType: string;
    createResponse() { return new UpdateBrandFeatureSectionBackgroundMediaResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionBackgroundMedia"; }
}

export class UpdateBrandFeatureSectionSortOrder implements IReturn<UpdateBrandFeatureSectionSortOrderResponse>
{
    brandFeatureId: number;
    sectionIds: number[];
    createResponse() { return new UpdateBrandFeatureSectionSortOrderResponse(); }
    getTypeName() { return "UpdateBrandFeatureSectionSortOrder"; }
}

export class DeleteBrandFeatureSection implements IReturn<DeleteBrandFeatureSectionResponse>
{
    featureSectionId: number;
    createResponse() { return new DeleteBrandFeatureSectionResponse(); }
    getTypeName() { return "DeleteBrandFeatureSection"; }
}

export class CreateProductSet implements IReturn<CreateProductSetResponse>
{
    name: string;
    floorId: number;
    createResponse() { return new CreateProductSetResponse(); }
    getTypeName() { return "CreateProductSet"; }
}

export class DeleteProductSet implements IReturn<DeleteProductSetResponse>
{
    productSetId: number;
    createResponse() { return new DeleteProductSetResponse(); }
    getTypeName() { return "DeleteProductSet"; }
}

export class GetBrandsList implements IReturn<GetBrandsListResponse>
{
    maxAgeDays: number;
    createResponse() { return new GetBrandsListResponse(); }
    getTypeName() { return "GetBrandsList"; }
}

export class GetMagazineEditionsList implements IReturn<GetMagazineEditionsListResponse>
{
    maxAgeDays: number;
    createResponse() { return new GetMagazineEditionsListResponse(); }
    getTypeName() { return "GetMagazineEditionsList"; }
}

export class GetProductSet implements IReturn<GetProductSetResponse>
{
    productSetId: number;
    createResponse() { return new GetProductSetResponse(); }
    getTypeName() { return "GetProductSet"; }
}

export class GetProductSetFloors implements IReturn<GetProductSetFloorsResponse>
{
    createResponse() { return new GetProductSetFloorsResponse(); }
    getTypeName() { return "GetProductSetFloors"; }
}

export class GetProductSetsForFloor implements IReturn<GetProductSetsForFloorResponse>
{
    floorId: number;
    createResponse() { return new GetProductSetsForFloorResponse(); }
    getTypeName() { return "GetProductSetsForFloor"; }
}

export class GetProductsForBrand implements IReturn<GetProductsForBrandResponse>
{
    brandId: number;
    maxAgeDays: number;
    createResponse() { return new GetProductsForBrandResponse(); }
    getTypeName() { return "GetProductsForBrand"; }
}

export class GetProductsForMagazineEdition implements IReturn<GetProductsForMagazineEditionResponse>
{
    editionId: number;
    createResponse() { return new GetProductsForMagazineEditionResponse(); }
    getTypeName() { return "GetProductsForMagazineEdition"; }
}

export class UpdateProductSet implements IReturn<UpdateProductSetResponse>
{
    productSetId: number;
    name: string;
    createResponse() { return new UpdateProductSetResponse(); }
    getTypeName() { return "UpdateProductSet"; }
}

export class UpdateProductSetHidden implements IReturn<UpdateProductSetHiddenResponse>
{
    productSetId: number;
    hidden: boolean;
    createResponse() { return new UpdateProductSetHiddenResponse(); }
    getTypeName() { return "UpdateProductSetHidden"; }
}

export class UpdateProductSetImage implements IReturn<UpdateProductSetImageResponse>
{
    productSetId: number;
    imageBase64: string;
    imageContentType: string;
    createResponse() { return new UpdateProductSetImageResponse(); }
    getTypeName() { return "UpdateProductSetImage"; }
}

export class UpdateProductSetProducts implements IReturn<UpdateProductSetProductsResponse>
{
    productSetId: number;
    productIds: number[];
    createResponse() { return new UpdateProductSetProductsResponse(); }
    getTypeName() { return "UpdateProductSetProducts"; }
}

export class UpdateProductSetSummaryText implements IReturn<UpdateProductSetSummaryTextResponse>
{
    productSetId: number;
    summaryText: string;
    createResponse() { return new UpdateProductSetSummaryTextResponse(); }
    getTypeName() { return "UpdateProductSetSummaryText"; }
}

export class UpdateProductSetTeaserProducts implements IReturn<UpdateProductSetTeaserProductsResponse>
{
    productSetId: number;
    productIds: number[];
    createResponse() { return new UpdateProductSetTeaserProductsResponse(); }
    getTypeName() { return "UpdateProductSetTeaserProducts"; }
}

export class GetFloors implements IReturn<GetFloorsResponse>
{
    createResponse() { return new GetFloorsResponse(); }
    getTypeName() { return "GetFloors"; }
}

export class GetFloor implements IReturn<GetFloorResponse>
{
    floorId: number;
    createResponse() { return new GetFloorResponse(); }
    getTypeName() { return "GetFloor"; }
}

export class Initialise implements IReturn<InitialiseResponse>
{
    createResponse() { return new InitialiseResponse(); }
    getTypeName() { return "Initialise"; }
}

export class GetTitlePublishers implements IReturn<GetTitlePublishersResponse>
{
    createResponse() { return new GetTitlePublishersResponse(); }
    getTypeName() { return "GetTitlePublishers"; }
}

export class CreateMagazineTitle implements IReturn<CreateMagazineTitleResponse>
{
    publisherId: number;
    name: string;
    createResponse() { return new CreateMagazineTitleResponse(); }
    getTypeName() { return "CreateMagazineTitle"; }
}

export class CreateMagazineEdition implements IReturn<CreateMagazineEditionResponse>
{
    titleGroupId: number;
    name: string;
    publishDate: string;
    createResponse() { return new CreateMagazineEditionResponse(); }
    getTypeName() { return "CreateMagazineEdition"; }
}

export class CreateMagazinePage implements IReturn<CreateMagazinePageResponse>
{
    editionId: number;
    pageNumber: number;
    createResponse() { return new CreateMagazinePageResponse(); }
    getTypeName() { return "CreateMagazinePage"; }
}

export class GetMagazineTitles implements IReturn<GetMagazineTitlesResponse>
{
    maxEditionAgeDays: number;
    createResponse() { return new GetMagazineTitlesResponse(); }
    getTypeName() { return "GetMagazineTitles"; }
}

export class GetMagazineEditions implements IReturn<GetMagazineEditionsResponse>
{
    titleGroupId: number;
    maxEditionAgeDays: number;
    createResponse() { return new GetMagazineEditionsResponse(); }
    getTypeName() { return "GetMagazineEditions"; }
}

export class GetEditionContentByPage implements IReturn<GetEditionContentByPageResponse>
{
    id: number;
    createResponse() { return new GetEditionContentByPageResponse(); }
    getTypeName() { return "GetEditionContentByPage"; }
}

export class CaptureOrderFunds implements IReturn<CaptureOrderFundsResponse>
{
    orderId: number;
    createResponse() { return new CaptureOrderFundsResponse(); }
    getTypeName() { return "CaptureOrderFunds"; }
}

export class GetUserOrderHistory implements IReturn<GetUserOrderHistoryResponse>
{
    searchTerm: string;
    createResponse() { return new GetUserOrderHistoryResponse(); }
    getTypeName() { return "GetUserOrderHistory"; }
}

export class CancelOrder implements IReturn<CancelOrderResponse>
{
    orderId: number;
    createResponse() { return new CancelOrderResponse(); }
    getTypeName() { return "CancelOrder"; }
}

export class SendOrderMessage implements IReturn<SendOrderMessageResponse>
{
    orderId: number;
    message: string;
    sendUserCopy: boolean;
    createResponse() { return new SendOrderMessageResponse(); }
    getTypeName() { return "SendOrderMessage"; }
}

export class GetUserOrderSummary implements IReturn<GetUserOrderSummaryResponse>
{
    productId: number;
    optionId: number;
    quantity: number;
    purchasingPin: string;
    createResponse() { return new GetUserOrderSummaryResponse(); }
    getTypeName() { return "GetUserOrderSummary"; }
}

export class ConfirmUserOrder implements IReturn<ConfirmUserOrderResponse>
{
    anonymousUserName: string;
    anonymousUserEmail: string;
    purchasingPIN: string;
    productId: number;
    productOptionId: number;
    quantity: number;
    deliveryDetails: UserOrderDeliveryDetailsDTO;
    paymentDetails: UserOrderPaymentDetailsDTO;
    createResponse() { return new ConfirmUserOrderResponse(); }
    getTypeName() { return "ConfirmUserOrder"; }
}

export class ReconfirmUserOrder implements IReturn<ReconfirmUserOrderResponse>
{
    orderId: number;
    anonymousUserName: string;
    anonymousUserEmail: string;
    purchasingPIN: string;
    productOptionId: number;
    quantity: number;
    deliveryDetails: UserOrderDeliveryDetailsDTO;
    paymentDetails: UserOrderPaymentDetailsDTO;
    createResponse() { return new ReconfirmUserOrderResponse(); }
    getTypeName() { return "ReconfirmUserOrder"; }
}

export class AuthenticateUserOrder implements IReturn<AuthenticateUserOrderResponse>
{
    orderId: number;
    saveAddress: boolean;
    saveAddressAs: string;
    setAddressAsDefault: boolean;
    saveCard: boolean;
    saveCardAs: string;
    setCardAsDefault: boolean;
    createResponse() { return new AuthenticateUserOrderResponse(); }
    getTypeName() { return "AuthenticateUserOrder"; }
}

export class GetProduct2 implements IReturn<GetProduct2Response>
{
    productId: number;
    createResponse() { return new GetProduct2Response(); }
    getTypeName() { return "GetProduct2"; }
}

export class CreateProduct2 implements IReturn<CreateProduct2Response>
{
    formMode: ProductFormMode;
    product: CreateProductDTO;
    createResponse() { return new CreateProduct2Response(); }
    getTypeName() { return "CreateProduct2"; }
}

export class UpdateProduct2 implements IReturn<UpdateProduct2Response>
{
    formMode: ProductFormMode;
    product: UpdateProductDTO;
    createResponse() { return new UpdateProduct2Response(); }
    getTypeName() { return "UpdateProduct2"; }
}

export class GetAllProductPrimaryActions implements IReturn<GetAllProductPrimaryActionsResponse>
{
    createResponse() { return new GetAllProductPrimaryActionsResponse(); }
    getTypeName() { return "GetAllProductPrimaryActions"; }
}

export class GetAllProductBrands implements IReturn<GetAllProductBrandsResponse>
{
    createResponse() { return new GetAllProductBrandsResponse(); }
    getTypeName() { return "GetAllProductBrands"; }
}

export class SearchBrands implements IReturn<SearchBrandsResponse>
{
    searchTerm: string;
    createResponse() { return new SearchBrandsResponse(); }
    getTypeName() { return "SearchBrands"; }
}

export class GetAllProductCategories implements IReturn<GetAllProductCategoriesResponse>
{
    createResponse() { return new GetAllProductCategoriesResponse(); }
    getTypeName() { return "GetAllProductCategories"; }
}

export class GetProductDetailForEdit implements IReturn<GetProductDetailForEditResponse>
{
    productId: number;
    createResponse() { return new GetProductDetailForEditResponse(); }
    getTypeName() { return "GetProductDetailForEdit"; }
}

export class GetProductDetail extends BaseRequest implements IReturn<GetProductDetailResponse>
{
    productId: number;
    createResponse() { return new GetProductDetailResponse(); }
    getTypeName() { return "GetProductDetail"; }
}

export class ShareProduct implements IReturn<ShareProductResponse>
{
    productId: number;
    email: string;
    message: string;
    createResponse() { return new ShareProductResponse(); }
    getTypeName() { return "ShareProduct"; }
}

export class Signup implements IReturn<SignupResponse>
{
    fullName: string;
    emailAddress: string;
    password: string;
    confirmPassword: string;
    createResponse() { return new SignupResponse(); }
    getTypeName() { return "Signup"; }
}

export class SignupFromOrder implements IReturn<SignupFromOrderResponse>
{
    orderId: number;
    orderToken: string;
    password: string;
    confirmPassword: string;
    createResponse() { return new SignupFromOrderResponse(); }
    getTypeName() { return "SignupFromOrder"; }
}

export class CreateNewUser implements IReturn<CreateNewUserResponse>
{
    emailAddress: string;
    name: string;
    password: string;
    roles: UserRoleDTO[];
    createResponse() { return new CreateNewUserResponse(); }
    getTypeName() { return "CreateNewUser"; }
}

export class GetUserList implements IReturn<GetUserListResponse>
{
    createdStart: string;
    createdEnd: string;
    showAdministrators: boolean;
    createResponse() { return new GetUserListResponse(); }
    getTypeName() { return "GetUserList"; }
}

export class GetUserDetail implements IReturn<GetUserDetailResponse>
{
    userId: number;
    createResponse() { return new GetUserDetailResponse(); }
    getTypeName() { return "GetUserDetail"; }
}

export class GetUserEvents implements IReturn<GetUserEventsResponse>
{
    somethingId: number;
    createResponse() { return new GetUserEventsResponse(); }
    getTypeName() { return "GetUserEvents"; }
}

export class SetUserDetail implements IReturn<SetUserDetailResponse>
{
    userId: number;
    name: string;
    createResponse() { return new SetUserDetailResponse(); }
    getTypeName() { return "SetUserDetail"; }
}

export class GetRolesList implements IReturn<GetRolesListResponse>
{
    createResponse() { return new GetRolesListResponse(); }
    getTypeName() { return "GetRolesList"; }
}

export class GetRoleOptionsList implements IReturn<GetRoleOptionsListResponse>
{
    roleIdentifier: string;
    createResponse() { return new GetRoleOptionsListResponse(); }
    getTypeName() { return "GetRoleOptionsList"; }
}

export class AddUserRole implements IReturn<AddUserRoleResponse>
{
    userId: number;
    role: UserRoleDTO;
    createResponse() { return new AddUserRoleResponse(); }
    getTypeName() { return "AddUserRole"; }
}

export class RemoveUserRole implements IReturn<RemoveUserRoleResponse>
{
    userId: number;
    role: UserRoleDTO;
    createResponse() { return new RemoveUserRoleResponse(); }
    getTypeName() { return "RemoveUserRole"; }
}

export class GenerateUserPassword implements IReturn<GenerateUserPasswordResponse>
{
    createResponse() { return new GenerateUserPasswordResponse(); }
    getTypeName() { return "GenerateUserPassword"; }
}

export class UpdateUserPassword implements IReturn<UpdateUserPasswordResponse>
{
    userId: number;
    password: string;
    createResponse() { return new UpdateUserPasswordResponse(); }
    getTypeName() { return "UpdateUserPassword"; }
}

export class RequestUserPasswordReset implements IReturn<RequestUserPasswordResetResponse>
{
    userId: number;
    createResponse() { return new RequestUserPasswordResetResponse(); }
    getTypeName() { return "RequestUserPasswordReset"; }
}

export class GetUserLists implements IReturn<GetUserListsResponse>
{
    contextProductId: number;
    createResponse() { return new GetUserListsResponse(); }
    getTypeName() { return "GetUserLists"; }
}

export class AddUserList extends BaseRequest implements IReturn<AddUserListResponse>
{
    contextProductId: number;
    name: string;
    createResponse() { return new AddUserListResponse(); }
    getTypeName() { return "AddUserList"; }
}

export class AddProductToUserList extends BaseRequest implements IReturn<AddProductToUserListResponse>
{
    userListId: number;
    productId: number;
    createResponse() { return new AddProductToUserListResponse(); }
    getTypeName() { return "AddProductToUserList"; }
}

export class RemoveProductFromUserList extends BaseRequest implements IReturn<RemoveProductFromUserListResponse>
{
    userListId: number;
    productId: number;
    createResponse() { return new RemoveProductFromUserListResponse(); }
    getTypeName() { return "RemoveProductFromUserList"; }
}

export class RemoveProductFromHistory extends BaseRequest implements IReturn<RemoveProductFromUserListResponse>
{
    productId: number;
    createResponse() { return new RemoveProductFromUserListResponse(); }
    getTypeName() { return "RemoveProductFromHistory"; }
}

export class RequestPasswordReset implements IReturn<RequestPasswordResetResponse>
{
    accountEmailAddress: string;
    createResponse() { return new RequestPasswordResetResponse(); }
    getTypeName() { return "RequestPasswordReset"; }
}

export class AcceptPasswordReset implements IReturn<AcceptPasswordResetResponse>
{
    token: string;
    newPassword: string;
    confirmNewPassword: string;
    createResponse() { return new AcceptPasswordResetResponse(); }
    getTypeName() { return "AcceptPasswordReset"; }
}

export class GetUserPreferences implements IReturn<GetUserPreferencesResponse>
{
    createResponse() { return new GetUserPreferencesResponse(); }
    getTypeName() { return "GetUserPreferences"; }
}

export class SetUserSmartBrowsing implements IReturn<SetUserSmartBrowsingResponse>
{
    smartBrowsingActive: boolean;
    smartBrowsingDeactivationWarning: boolean;
    createResponse() { return new SetUserSmartBrowsingResponse(); }
    getTypeName() { return "SetUserSmartBrowsing"; }
}

export class AddSavedAddress implements IReturn<AddSavedAddressResponse>, IUserSettingsRequest
{
    token: string;
    displayName: string;
    isDefault: boolean;
    recipientName: string;
    street: string;
    townOrCity: string;
    county: string;
    postCode: string;
    phone: string;
    createResponse() { return new AddSavedAddressResponse(); }
    getTypeName() { return "AddSavedAddress"; }
}

export class RemoveSavedAddress implements IReturn<RemoveSavedAddressResponse>, IUserSettingsRequest
{
    token: string;
    savedAddressId: number;
    createResponse() { return new RemoveSavedAddressResponse(); }
    getTypeName() { return "RemoveSavedAddress"; }
}

export class UpdateSavedAddress implements IReturn<UpdateSavedAddressResponse>, IUserSettingsRequest
{
    token: string;
    savedAddressId: number;
    displayName: string;
    recipientName: string;
    street: string;
    townOrCity: string;
    county: string;
    postCode: string;
    phone: string;
    createResponse() { return new UpdateSavedAddressResponse(); }
    getTypeName() { return "UpdateSavedAddress"; }
}

export class SetDefaultSavedAddress implements IReturn<SetDefaultSavedAddressResponse>, IUserSettingsRequest
{
    token: string;
    savedAddressId: number;
    createResponse() { return new SetDefaultSavedAddressResponse(); }
    getTypeName() { return "SetDefaultSavedAddress"; }
}

export class AddSavedCard implements IReturn<AddSavedCardResponse>, IUserSettingsRequest
{
    token: string;
    displayName: string;
    isDefault: boolean;
    paymentMethodId: string;
    createResponse() { return new AddSavedCardResponse(); }
    getTypeName() { return "AddSavedCard"; }
}

export class RemoveSavedCard implements IReturn<RemoveSavedCardResponse>, IUserSettingsRequest
{
    token: string;
    savedCardId: number;
    createResponse() { return new RemoveSavedCardResponse(); }
    getTypeName() { return "RemoveSavedCard"; }
}

export class SetDefaultSavedCard implements IReturn<SetDefaultSavedCardResponse>, IUserSettingsRequest
{
    token: string;
    savedCardId: number;
    createResponse() { return new SetDefaultSavedCardResponse(); }
    getTypeName() { return "SetDefaultSavedCard"; }
}

export class GetUserSettings implements IReturn<GetUserSettingsResponse>, IUserSettingsRequest
{
    token: string;
    createResponse() { return new GetUserSettingsResponse(); }
    getTypeName() { return "GetUserSettings"; }
}

export class SetUserDetails implements IReturn<SetUserDetailsResponse>, IUserSettingsRequest
{
    token: string;
    fullName: string;
    createResponse() { return new SetUserDetailsResponse(); }
    getTypeName() { return "SetUserDetails"; }
}

export class SetUserPassword implements IReturn<SetUserPasswordResponse>, IUserSettingsRequest
{
    token: string;
    password: string;
    confirmPassword: string;
    createResponse() { return new SetUserPasswordResponse(); }
    getTypeName() { return "SetUserPassword"; }
}

export class SetUserPrivacyConsent implements IReturn<SetUserPrivacyConsentResponse>, IUserSettingsRequest
{
    token: string;
    privacyConsent: boolean;
    createResponse() { return new SetUserPrivacyConsentResponse(); }
    getTypeName() { return "SetUserPrivacyConsent"; }
}

export class GetUserSettingsToken implements IReturn<GetUserSettingsTokenResponse>
{
    password: string;
    createResponse() { return new GetUserSettingsTokenResponse(); }
    getTypeName() { return "GetUserSettingsToken"; }
}

export class ValidateUserSettingsToken implements IReturn<ValidateUserSettingsTokenResponse>
{
    token: string;
    createResponse() { return new ValidateUserSettingsTokenResponse(); }
    getTypeName() { return "ValidateUserSettingsToken"; }
}

export class SendSupportMessage implements IReturn<SendSupportMessageResponse>
{
    subject: string;
    message: string;
    createResponse() { return new SendSupportMessageResponse(); }
    getTypeName() { return "SendSupportMessage"; }
}

export class GetFloorPlan implements IReturn<GetFloorPlanResponse>
{
    floorId: number;
    createResponse() { return new GetFloorPlanResponse(); }
    getTypeName() { return "GetFloorPlan"; }
}

export class AddFloorRegion implements IReturn<AddFloorRegionResponse>
{
    floorId: number;
    departmentId: number;
    x: number;
    y: number;
    createResponse() { return new AddFloorRegionResponse(); }
    getTypeName() { return "AddFloorRegion"; }
}

export class ClearFloorRegion implements IReturn<ClearFloorRegionResponse>
{
    floorId: number;
    x: number;
    y: number;
    createResponse() { return new ClearFloorRegionResponse(); }
    getTypeName() { return "ClearFloorRegion"; }
}

export class MoveFloorRegion implements IReturn<MoveFloorRegionResponse>
{
    floorId: number;
    x: number;
    y: number;
    destinationX: number;
    destinationY: number;
    createResponse() { return new MoveFloorRegionResponse(); }
    getTypeName() { return "MoveFloorRegion"; }
}

export class AddFloorHorizontalPathway implements IReturn<AddFloorHorizontalPathwayResponse>
{
    floorId: number;
    y: number;
    createResponse() { return new AddFloorHorizontalPathwayResponse(); }
    getTypeName() { return "AddFloorHorizontalPathway"; }
}

export class RemoveFloorHorizontalPathway implements IReturn<RemoveFloorHorizontalPathwayResponse>
{
    floorId: number;
    y: number;
    createResponse() { return new RemoveFloorHorizontalPathwayResponse(); }
    getTypeName() { return "RemoveFloorHorizontalPathway"; }
}

export class AddFloorVerticalPathway implements IReturn<AddFloorVerticalPathwayResponse>
{
    floorId: number;
    x: number;
    createResponse() { return new AddFloorVerticalPathwayResponse(); }
    getTypeName() { return "AddFloorVerticalPathway"; }
}

export class RemoveFloorVerticalPathway implements IReturn<RemoveFloorVerticalPathwayResponse>
{
    floorId: number;
    x: number;
    createResponse() { return new RemoveFloorVerticalPathwayResponse(); }
    getTypeName() { return "RemoveFloorVerticalPathway"; }
}

export class GetFloorDepartmentPlan implements IReturn<GetFloorDepartmentPlanResponse>
{
    floorId: number;
    departmentId: number;
    createResponse() { return new GetFloorDepartmentPlanResponse(); }
    getTypeName() { return "GetFloorDepartmentPlan"; }
}

export class AddFloorDisplay implements IReturn<AddFloorDisplayResponse>
{
    floorId: number;
    departmentId: number;
    displayId: number;
    x: number;
    y: number;
    createResponse() { return new AddFloorDisplayResponse(); }
    getTypeName() { return "AddFloorDisplay"; }
}

export class ClearFloorDisplay implements IReturn<ClearFloorDisplayResponse>
{
    floorId: number;
    departmentId: number;
    x: number;
    y: number;
    createResponse() { return new ClearFloorDisplayResponse(); }
    getTypeName() { return "ClearFloorDisplay"; }
}

export class MoveFloorDisplay implements IReturn<MoveFloorDisplayResponse>
{
    floorId: number;
    departmentId: number;
    x: number;
    y: number;
    destinationX: number;
    destinationY: number;
    createResponse() { return new MoveFloorDisplayResponse(); }
    getTypeName() { return "MoveFloorDisplay"; }
}

export class SetFloorDepartmentFocusPoint implements IReturn<SetFloorDepartmentFocusPointResponse>
{
    floorId: number;
    departmentId: number;
    x: number;
    y: number;
    createResponse() { return new SetFloorDepartmentFocusPointResponse(); }
    getTypeName() { return "SetFloorDepartmentFocusPoint"; }
}

export class SetFloorDisplayGutterStyle implements IReturn<SetFloorDisplayGutterStyleResponse>
{
    floorId: number;
    departmentId: number;
    x: number;
    y: number;
    gutterStyle: FloorPlanDisplayGutterStyle;
    createResponse() { return new SetFloorDisplayGutterStyleResponse(); }
    getTypeName() { return "SetFloorDisplayGutterStyle"; }
}

export class AddVisualiserDepartment implements IReturn<AddVisualiserDepartmentResponse>
{
    floorId: number;
    name: string;
    createResponse() { return new AddVisualiserDepartmentResponse(); }
    getTypeName() { return "AddVisualiserDepartment"; }
}

export class AddVisualiserFloor implements IReturn<AddVisualiserFloorResponse>
{
    displayType: FloorDisplayType;
    name: string;
    createResponse() { return new AddVisualiserFloorResponse(); }
    getTypeName() { return "AddVisualiserFloor"; }
}

export class DeleteVisualiserDepartment implements IReturn<DeleteVisualiserDepartmentResponse>
{
    departmentId: number;
    createResponse() { return new DeleteVisualiserDepartmentResponse(); }
    getTypeName() { return "DeleteVisualiserDepartment"; }
}

export class DeleteVisualiserFloor implements IReturn<DeleteVisualiserFloorResponse>
{
    floorId: number;
    createResponse() { return new DeleteVisualiserFloorResponse(); }
    getTypeName() { return "DeleteVisualiserFloor"; }
}

export class GetVisualiserDepartmentMergeCandidates implements IReturn<GetVisualiserDepartmentMergeCandidatesResponse>
{
    departmentId: number;
    createResponse() { return new GetVisualiserDepartmentMergeCandidatesResponse(); }
    getTypeName() { return "GetVisualiserDepartmentMergeCandidates"; }
}

export class GetVisualiserDepartments implements IReturn<GetVisualiserDepartmentsResponse>
{
    floorId: number;
    createResponse() { return new GetVisualiserDepartmentsResponse(); }
    getTypeName() { return "GetVisualiserDepartments"; }
}

export class GetVisualiserDisplays implements IReturn<GetVisualiserDisplaysResponse>
{
    departmentId: number;
    createResponse() { return new GetVisualiserDisplaysResponse(); }
    getTypeName() { return "GetVisualiserDisplays"; }
}

export class GetVisualiserPendingDisplays implements IReturn<GetVisualiserPendingDisplaysResponse>
{
    floorId: number;
    createResponse() { return new GetVisualiserPendingDisplaysResponse(); }
    getTypeName() { return "GetVisualiserPendingDisplays"; }
}

export class MoveVisualiserDisplay implements IReturn<MoveVisualiserDisplayResponse>
{
    floorId: number;
    displayId: number;
    destinationDepartmentId: number;
    createResponse() { return new MoveVisualiserDisplayResponse(); }
    getTypeName() { return "MoveVisualiserDisplay"; }
}

export class GetVisualiserFloors implements IReturn<GetVisualiserFloorsResponse>
{
    createResponse() { return new GetVisualiserFloorsResponse(); }
    getTypeName() { return "GetVisualiserFloors"; }
}

export class MergeVisualiserDepartments implements IReturn<MergeVisualiserDepartmentsResponse>
{
    sourceDepartmentId: number;
    destinationDepartmentId: number;
    createResponse() { return new MergeVisualiserDepartmentsResponse(); }
    getTypeName() { return "MergeVisualiserDepartments"; }
}

export class MoveVisualiserDepartment implements IReturn<MoveVisualiserDepartmentResponse>
{
    departmentId: number;
    floorId: number;
    createResponse() { return new MoveVisualiserDepartmentResponse(); }
    getTypeName() { return "MoveVisualiserDepartment"; }
}

export class SetVisualiserFloorAsDefault implements IReturn<SetVisualiserFloorAsDefaultResponse>
{
    floorId: number;
    createResponse() { return new SetVisualiserFloorAsDefaultResponse(); }
    getTypeName() { return "SetVisualiserFloorAsDefault"; }
}

export class SetVisualiserFloorsOrder implements IReturn<SetVisualiserFloorsOrderResponse>
{
    floorIds: number[];
    createResponse() { return new SetVisualiserFloorsOrderResponse(); }
    getTypeName() { return "SetVisualiserFloorsOrder"; }
}

export class UpdateVisualiserDepartment implements IReturn<UpdateVisualiserDepartmentResponse>
{
    departmentId: number;
    name: string;
    hidden: boolean;
    createResponse() { return new UpdateVisualiserDepartmentResponse(); }
    getTypeName() { return "UpdateVisualiserDepartment"; }
}

export class UpdateVisualiserFloor implements IReturn<UpdateVisualiserFloorResponse>
{
    floorId: number;
    name: string;
    hidden: boolean;
    createResponse() { return new UpdateVisualiserFloorResponse(); }
    getTypeName() { return "UpdateVisualiserFloor"; }
}

// @Route("/api.v1/website/{WebsiteId}/product-breakdown")
export class GetEditionProductSummaryStats extends BaseRequest implements IReturn<GetEditionProductSummaryStatsResponse>
{
    websiteId: number;
    createResponse() { return new GetEditionProductSummaryStatsResponse(); }
    getTypeName() { return "GetEditionProductSummaryStats"; }
}

// @Route("/api.v1/referrals/summary/website/{WebsiteId}")
export class GetWebsiteEventSummaryStats extends BaseRequest implements IReturn<GetWebsiteEventSummaryStatsResponse>
{
    websiteId: number;
    createResponse() { return new GetWebsiteEventSummaryStatsResponse(); }
    getTypeName() { return "GetWebsiteEventSummaryStats"; }
}

// @Route("/api.v1/events", "POST")
export class CreateLogEvent extends LogEvent implements IReturn<CreateLogEventResponse>
{
    createResponse() { return new CreateLogEventResponse(); }
    getTypeName() { return "CreateLogEvent"; }
}

// @Route("/api.v1/orders", "GET")
export class GetOrders extends BaseRequest implements IReturn<GetOrdersResponse>
{
    startDate: string;
    endDate: string;
    supplierId: number;
    allocated: boolean;
    brands: string[];
    createResponse() { return new GetOrdersResponse(); }
    getTypeName() { return "GetOrders"; }
}

// @Route("/api.v1/orders/brands", "GET")
// @Route("/api.v1/orders", "GET")
export class GetOrdersBrands extends GetOrders implements IReturn<GetOrdersResponse>
{
    createResponse() { return new GetOrdersResponse(); }
    getTypeName() { return "GetOrdersBrands"; }
}

// @Route("/api.v1/orders/suppliers", "GET")
// @Route("/api.v1/orders", "GET")
export class GetOrdersSuppliers extends GetOrders implements IReturn<GetOrdersResponse>
{
    createResponse() { return new GetOrdersResponse(); }
    getTypeName() { return "GetOrdersSuppliers"; }
}

// @Route("/api.v1/orders/users", "GET")
// @Route("/api.v1/orders", "GET")
export class GetOrdersUsers extends GetOrders implements IReturn<GetOrdersResponse>
{
    createResponse() { return new GetOrdersResponse(); }
    getTypeName() { return "GetOrdersUsers"; }
}

// @Route("/api.v1/publishers/{PublisherId}/orders", "GET")
export class GetPublisherOrders extends BaseRequest implements IReturn<GetPublisherOrdersResponse>
{
    publisherId: number;
    startDate: string;
    endDate: string;
    websiteId: number;
    createResponse() { return new GetPublisherOrdersResponse(); }
    getTypeName() { return "GetPublisherOrders"; }
}

// @Route("/api.v1/users/{UserId}/orders", "GET")
export class GetUserOrders extends BaseRequest implements IReturn<GetUserOrdersResponse>
{
    userId: number;
    startDate: string;
    endDate: string;
    createResponse() { return new GetUserOrdersResponse(); }
    getTypeName() { return "GetUserOrders"; }
}

// @Route("/api.v1/orders/{Id}", "GET")
export class GetOrder extends BaseRequest implements IReturn<GetOrderResponse>
{
    id: number;
    includeHistory: boolean;
    createResponse() { return new GetOrderResponse(); }
    getTypeName() { return "GetOrder"; }
}

// @Route("/api.v1/orders/{Id}", "DELETE")
export class DeleteOrder extends BaseRequest implements IReturn<DeleteOrderResponse>
{
    id: number;
    createResponse() { return new DeleteOrderResponse(); }
    getTypeName() { return "DeleteOrder"; }
}

// @Route("/api.v1/orders/{Id}/history", "GET")
export class GetOrderHistory extends BaseRequest implements IReturn<GetOrderHistoryResponse>
{
    id: number;
    createResponse() { return new GetOrderHistoryResponse(); }
    getTypeName() { return "GetOrderHistory"; }
}

// @Route("/api.v1/user/purchases/suppliers", "GET")
export class GetPurchaseSuppliers extends BaseRequest implements IReturn<GetPurchaseSuppliersResponse>
{
    filter: PurchasesFilter;
    createResponse() { return new GetPurchaseSuppliersResponse(); }
    getTypeName() { return "GetPurchaseSuppliers"; }
}

// @Route("/api.v1/user/purchases/sources", "GET")
export class GetPurchaseSources extends BaseRequest implements IReturn<GetPurchaseSourcesResponse>
{
    filter: PurchasesFilter;
    createResponse() { return new GetPurchaseSourcesResponse(); }
    getTypeName() { return "GetPurchaseSources"; }
}

// @Route("/api.v1/user/orders", "GET")
// @Route("/api.v1/user/purchases", "GET")
export class GetCurrentUserOrders extends BaseRequest implements IReturn<GetCurrentUserOrdersResponse>
{
    filter: PurchasesFilter;
    createResponse() { return new GetCurrentUserOrdersResponse(); }
    getTypeName() { return "GetCurrentUserOrders"; }
}

// @Route("/api.v1/user/orders/{Id}", "GET")
// @Route("/api.v1/user/purchases/{Id}", "GET")
export class GetCurrentUserOrder extends BaseRequest implements IReturn<GetCurrentUserOrderResponse>
{
    id: number;
    createResponse() { return new GetCurrentUserOrderResponse(); }
    getTypeName() { return "GetCurrentUserOrder"; }
}

// @Route("/api.v1/user/orders/{Id}/message", "POST")
// @Route("/api.v1/user/orders/{Id}/items/{ItemId}/message", "POST")
export class SendMessagePurchase extends BaseRequest implements IReturn<SendMessagePurchaseResponse>
{
    id: number;
    itemId: number;
    message: string;
    copyMe: boolean;
    createResponse() { return new SendMessagePurchaseResponse(); }
    getTypeName() { return "SendMessagePurchase"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}/messages", "POST")
// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}/items/{ItemId}/messages", "POST")
export class SupplierSendMessage extends BaseRequest implements IReturn<SupplierSendMessageResponse>
{
    supplierId: number;
    orderId: number;
    itemId: number;
    subject: string;
    message: string;
    createResponse() { return new SupplierSendMessageResponse(); }
    getTypeName() { return "SupplierSendMessage"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}/reject", "POST")
// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}/items/{ItemId}/reject", "POST")
export class SupplierRejectOrder extends BaseRequest implements IReturn<SupplierRejectOrderResponse>
{
    supplierId: number;
    orderId: number;
    itemId: number;
    reason: string;
    createResponse() { return new SupplierRejectOrderResponse(); }
    getTypeName() { return "SupplierRejectOrder"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}/items/{ItemId}/bids/{BidId}", "POST")
export class AcceptBid extends BaseRequest implements IReturn<AcceptBidResponse>, IPost
{
    supplierId: number;
    orderId: number;
    itemId: number;
    bidId: number;
    trackingId: string;
    trackingMethod: string;
    status: OrderBidStatus;
    createResponse() { return new AcceptBidResponse(); }
    getTypeName() { return "AcceptBid"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}/items/{ItemId}", "POST")
export class SupplierUpdateOrder extends BaseRequest implements IReturn<SupplierUpdateOrderResponse>
{
    supplierId: number;
    orderId: number;
    itemId: number;
    deliveryDate: string;
    trackingMethod: string;
    trackingId: string;
    createResponse() { return new SupplierUpdateOrderResponse(); }
    getTypeName() { return "SupplierUpdateOrder"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/{Id}/refund", "POST")
// @Route("/api.v1/suppliers/{SupplierId}/orders/{Id}/items/{ItemId}/refund", "POST")
export class SupplierRefundOrder extends BaseRequest implements IReturn<SupplierRefundOrderResponse>
{
    supplierId: number;
    id: number;
    itemId: number;
    approve: boolean;
    accept: boolean;
    reason: string;
    total: number;
    createResponse() { return new SupplierRefundOrderResponse(); }
    getTypeName() { return "SupplierRefundOrder"; }
}

// @Route("/referral")
export class AcceptReferral implements IReturn<AcceptReferralResponse>
{
    id: string;
    createResponse() { return new AcceptReferralResponse(); }
    getTypeName() { return "AcceptReferral"; }
}

// @Route("/referralid")
export class AcceptAlternateReferral implements IReturn<AcceptAlternateReferralResponse>
{
    createResponse() { return new AcceptAlternateReferralResponse(); }
    getTypeName() { return "AcceptAlternateReferral"; }
}

// @Route("/referralsreport")
export class GetReferralsReport
{
    format: string;
}

// @Route("/productlink", "GET")
export class RedirectToProductLink implements IReturnVoid
{
    pid: number;
    createResponse() {}
    getTypeName() { return "RedirectToProductLink"; }
}

// @Route("/api.v1/publishers/{PublisherId}/editionsummaries", "GET")
export class GetPublisherEditionSummaries implements IReturn<GetPublisherEditionSummariesResponse>
{
    publisherId: number;
    createResponse() { return new GetPublisherEditionSummariesResponse(); }
    getTypeName() { return "GetPublisherEditionSummaries"; }
}

// @Route("/api.v1/referrals/popularity/products", "POST")
export class GetProductPopularityStats extends BaseRequest implements IReturn<GetProductPopularityStatsResponse>, IPopularityStatsRequest
{
    publisherId: number;
    publisherGroupId: number;
    sortBy: ReferralTypes;
    since: string;
    sortAscending: boolean;
    createResponse() { return new GetProductPopularityStatsResponse(); }
    getTypeName() { return "GetProductPopularityStats"; }
}

// @Route("/api.v1/referrals/popularity/brands", "POST")
export class GetProductBrandPopularityStats extends BaseRequest implements IReturn<GetProductBrandPopularityStatsResponse>, IPopularityStatsRequest
{
    publisherId: number;
    publisherGroupId: number;
    sortBy: ReferralTypes;
    sortAscending: boolean;
    since: string;
    createResponse() { return new GetProductBrandPopularityStatsResponse(); }
    getTypeName() { return "GetProductBrandPopularityStats"; }
}

// @Route("/api.v1/referrals/popularity/producttypes", "POST")
export class GetProductTypePopularityStats extends BaseRequest implements IReturn<GetProductTypePopularityStatsResponse>, IPopularityStatsRequest
{
    publisherId: number;
    publisherGroupId: number;
    sortBy: ReferralTypes;
    sortAscending: boolean;
    since: string;
    createResponse() { return new GetProductTypePopularityStatsResponse(); }
    getTypeName() { return "GetProductTypePopularityStats"; }
}

// @Route("/api.v1/referrals/popularity/suppliers", "POST")
export class GetProductSupplierPopularityStats extends BaseRequest implements IReturn<GetProductSupplierPopularityStatsResponse>, IPopularityStatsRequest
{
    publisherId: number;
    publisherGroupId: number;
    sortBy: ReferralTypes;
    sortAscending: boolean;
    since: string;
    createResponse() { return new GetProductSupplierPopularityStatsResponse(); }
    getTypeName() { return "GetProductSupplierPopularityStats"; }
}

// @Route("/api.v1/publisher/{PublisherId}/affiliate-revenue")
export class GetPublisherAffiliateRevenueStats extends BaseRequest implements IReturn<GetPublisherAffiliateRevenueStatsResponse>
{
    publisherId: number;
    publisherGroupId: number;
    createResponse() { return new GetPublisherAffiliateRevenueStatsResponse(); }
    getTypeName() { return "GetPublisherAffiliateRevenueStats"; }
}

// @Route("/api.v1/referrals/summary/group/{PublisherGroupId}")
export class GetGroupEventSummaryStats extends BaseRequest implements IReturn<GetGroupEventSummaryStatsResponse>
{
    publisherGroupId: number;
    createResponse() { return new GetGroupEventSummaryStatsResponse(); }
    getTypeName() { return "GetGroupEventSummaryStats"; }
}

// @Route("/api.v1/exports/referrals")
export class ExportReferrals implements IReturn<Array<ReferralsCsvRowDTO>>
{
    supplierId: number;
    websiteId: number;
    startDate: string;
    endDate: string;
    createResponse() { return new Array<ReferralsCsvRowDTO>(); }
    getTypeName() { return "ExportReferrals"; }
}

// @Route("/api.v1/referrals", "GET")
export class GetReferrals extends BaseRequest implements IReturn<GetReferralsResponse>
{
    supplierId: number;
    productId: number;
    publisherId: number;
    websiteId: number;
    thingType: string;
    thingId: number;
    referralType: ReferralTypes;
    supplierName: string;
    productName: string;
    websiteName: string;
    createResponse() { return new GetReferralsResponse(); }
    getTypeName() { return "GetReferrals"; }
}

// @Route("/api.v1/referrals/{Id}", "GET")
export class GetReferral extends BaseRequest implements IReturn<GetReferralResponse>
{
    id: number;
    createResponse() { return new GetReferralResponse(); }
    getTypeName() { return "GetReferral"; }
}

// @Route("/api.v1/referrals", "POST")
export class CreateReferral extends BaseRequest implements IReturn<CreateReferralResponse>
{
    type: ReferralTypes;
    title: string;
    productId: number;
    thingType: string;
    thingId: number;
    websiteId: number;
    pageNumber: number;
    url: string;
    data: string;
    client: string;
    createResponse() { return new CreateReferralResponse(); }
    getTypeName() { return "CreateReferral"; }
}

// @Route("/api.v1/referrals/{Id}", "POST")
export class UpdateReferral extends BaseRequest implements IReturn<UpdateReferralResponse>
{
    id: number;
    type: ReferralTypes;
    title: string;
    productId: number;
    thingType: string;
    thingId: number;
    websiteId: number;
    pageNumber: number;
    url: string;
    data: string;
    createResponse() { return new UpdateReferralResponse(); }
    getTypeName() { return "UpdateReferral"; }
}

// @Route("/api.v1/referrals/{Id}", "DELETE")
export class DeleteReferral extends BaseRequest implements IReturn<DeleteReferralResponse>
{
    id: number;
    createResponse() { return new DeleteReferralResponse(); }
    getTypeName() { return "DeleteReferral"; }
}

// @Route("/productcapturereport")
export class GetProductCaptureReport
{
    since: string;
}

// @Route("/userreport")
export class GetUserReport
{
}

// @Route("/sharedproduct")
export class GetSharedProduct extends BaseRequest implements IReturn<GetSharedProductResponse>
{
    pid: number;
    createResponse() { return new GetSharedProductResponse(); }
    getTypeName() { return "GetSharedProduct"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/bids", "GET")
export class GetSupplierBids extends BaseRequest implements IReturn<GetSupplierBidsResponse>
{
    supplierId: number;
    status: OrderBidStatus;
    startDate: string;
    endDate: string;
    createResponse() { return new GetSupplierBidsResponse(); }
    getTypeName() { return "GetSupplierBids"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/bids", "POST")
export class CreateSupplierBid extends BaseRequest implements IReturn<CreateSupplierBidResponse>, IPost
{
    supplierId: number;
    orderId: number;
    orderItemId: number;
    price: number;
    postage: number;
    deliveryDate: string;
    trackingMethod: string;
    trackingId: string;
    referral: string;
    payment: string;
    returnDays: number;
    createResponse() { return new CreateSupplierBidResponse(); }
    getTypeName() { return "CreateSupplierBid"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/bids/{BidId}", "POST")
export class UpdateSupplierBid extends BaseRequest implements IReturn<UpdateSupplierBidResponse>, IPost
{
    supplierId: number;
    bidId: number;
    price: number;
    postage: number;
    deliveryDate: string;
    returnDays: number;
    referral: string;
    payment: string;
    createResponse() { return new UpdateSupplierBidResponse(); }
    getTypeName() { return "UpdateSupplierBid"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/bids/{BidId}", "DELETE")
export class DeleteSupplierBid extends BaseRequest implements IReturn<DeleteSupplierBidResponse>, IDelete
{
    supplierId: number;
    bidId: number;
    createResponse() { return new DeleteSupplierBidResponse(); }
    getTypeName() { return "DeleteSupplierBid"; }
}

// @Route("/api.v1/suppliers/brands", "GET")
export class GetSuppliersBrands extends BaseRequest implements IReturn<GetSuppliersBrandsResponse>, IGet
{
    createResponse() { return new GetSuppliersBrandsResponse(); }
    getTypeName() { return "GetSuppliersBrands"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/brands", "GET")
export class GetSupplierBrands extends BaseRequest implements IReturn<GetSupplierBrandsResponse>, IGet
{
    supplierId: number;
    createResponse() { return new GetSupplierBrandsResponse(); }
    getTypeName() { return "GetSupplierBrands"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/brands", "POST")
export class UpdateSupplierBrand extends BaseRequest implements IReturn<UpdateSupplierBrandResponse>
{
    supplierId: number;
    brands: string[];
    createResponse() { return new UpdateSupplierBrandResponse(); }
    getTypeName() { return "UpdateSupplierBrand"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/distributors", "GET")
export class GetSupplierDistributors extends BaseRequest implements IReturn<GetSupplierDistributorsResponse>
{
    supplierId: number;
    distributorId: number;
    createResponse() { return new GetSupplierDistributorsResponse(); }
    getTypeName() { return "GetSupplierDistributors"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/distributors/{DistributorId}", "GET")
export class GetSupplierDistributor extends BaseRequest implements IReturn<GetSupplierDistributorResponse>
{
    supplierId: number;
    distributorId: number;
    createResponse() { return new GetSupplierDistributorResponse(); }
    getTypeName() { return "GetSupplierDistributor"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/distributors", "POST")
export class CreateSupplierDistributor extends BaseRequest implements IReturn<CreateSupplierDistributorResponse>
{
    supplierId: number;
    distributorId: number;
    discount: number;
    createResponse() { return new CreateSupplierDistributorResponse(); }
    getTypeName() { return "CreateSupplierDistributor"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/distributors/{DistributorId}", "POST")
export class UpdateSupplierDistributor extends BaseRequest implements IReturn<UpdateSupplierDistributorResponse>
{
    supplierId: number;
    distributorId: number;
    discount: number;
    createResponse() { return new UpdateSupplierDistributorResponse(); }
    getTypeName() { return "UpdateSupplierDistributor"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/distributors/{DistributorId}", "DELETE")
export class DeleteSupplierDistributor extends BaseRequest implements IReturn<DeleteSupplierDistributorResponse>
{
    supplierId: number;
    distributorId: number;
    createResponse() { return new DeleteSupplierDistributorResponse(); }
    getTypeName() { return "DeleteSupplierDistributor"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/ledger/payees", "GET")
export class GetSupplierLedgerPayees extends BaseRequest implements IReturn<GetSupplierLedgerPayeesResponse>
{
    supplierId: number;
    distributorId: number;
    publisherId: number;
    partnerId: number;
    createResponse() { return new GetSupplierLedgerPayeesResponse(); }
    getTypeName() { return "GetSupplierLedgerPayees"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/ledger", "GET")
export class GetSupplierLedger extends BaseRequest implements IReturn<GetSupplierLedgerResponse>
{
    supplierId: number;
    withPayout: boolean;
    startDate: string;
    endDate: string;
    publisherId: number;
    distributorId: number;
    createResponse() { return new GetSupplierLedgerResponse(); }
    getTypeName() { return "GetSupplierLedger"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/ledger", "POST")
export class CreateSupplierLedger extends BaseRequest implements IReturn<CreateSupplierLedgerResponse>
{
    supplierId: number;
    ledgerIds: number[];
    distributorId: number;
    publisherId: number;
    date: string;
    amount: number;
    currency: string;
    paymentType: string;
    paymentAccount: string;
    paymentRef: string;
    createResponse() { return new CreateSupplierLedgerResponse(); }
    getTypeName() { return "CreateSupplierLedger"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/availableorders", "GET")
// @Route("/api.v1/availableorders", "GET")
export class GetAvailableOrders extends BaseRequest implements IReturn<GetAvailableOrdersResponse>
{
    supplierId: number;
    brands: string[];
    startDate: string;
    endDate: string;
    createResponse() { return new GetAvailableOrdersResponse(); }
    getTypeName() { return "GetAvailableOrders"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders", "GET")
export class GetSupplierOrders extends BaseRequest implements IReturn<GetSupplierOrdersResponse>
{
    supplierId: number;
    startDate: string;
    endDate: string;
    status: string;
    createResponse() { return new GetSupplierOrdersResponse(); }
    getTypeName() { return "GetSupplierOrders"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/{OrderId}", "GET")
export class GetSupplierOrder extends BaseRequest implements IReturn<GetSupplierOrderResponse>
{
    supplierId: number;
    orderId: number;
    includeFullHistory: boolean;
    createResponse() { return new GetSupplierOrderResponse(); }
    getTypeName() { return "GetSupplierOrder"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/orders/users", "GET")
export class GetSupplierOrdersUsers extends BaseRequest implements IReturn<GetSupplierOrdersUsersResponse>
{
    supplierId: number;
    startDate: string;
    endDate: string;
    createResponse() { return new GetSupplierOrdersUsersResponse(); }
    getTypeName() { return "GetSupplierOrdersUsers"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/publishers", "GET")
export class GetSupplierPublishers extends BaseRequest implements IReturn<GetSupplierPublishersResponse>
{
    supplierId: number;
    createResponse() { return new GetSupplierPublishersResponse(); }
    getTypeName() { return "GetSupplierPublishers"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/publishers/{PublisherId}", "GET")
export class GetSupplierPublisher extends BaseRequest implements IReturn<GetSupplierPublisherResponse>
{
    supplierId: number;
    publisherId: number;
    createResponse() { return new GetSupplierPublisherResponse(); }
    getTypeName() { return "GetSupplierPublisher"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/publishers", "POST")
export class CreateSupplierPublisher extends BaseRequest implements IReturn<CreateSupplierPublisherResponse>
{
    supplierId: number;
    publisherId: number;
    share: number;
    createResponse() { return new CreateSupplierPublisherResponse(); }
    getTypeName() { return "CreateSupplierPublisher"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/publishers/{PublisherId}", "POST")
export class UpdateSupplierPublisher extends BaseRequest implements IReturn<UpdateSupplierPublisherResponse>
{
    supplierId: number;
    publisherId: number;
    share: number;
    createResponse() { return new UpdateSupplierPublisherResponse(); }
    getTypeName() { return "UpdateSupplierPublisher"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/publishers/{PublisherId}", "DELETE")
export class DeleteSupplierPublisher extends BaseRequest implements IReturn<DeleteSupplierPublisherResponse>
{
    supplierId: number;
    publisherId: number;
    createResponse() { return new DeleteSupplierPublisherResponse(); }
    getTypeName() { return "DeleteSupplierPublisher"; }
}

// @Route("/api.v1/suppliers", "GET")
export class GetSuppliers extends BaseRequest implements IReturn<GetSuppliersResponse>
{
    type: SupplierRole;
    brand: string;
    createResponse() { return new GetSuppliersResponse(); }
    getTypeName() { return "GetSuppliers"; }
}

// @Route("/api.v1/user/suppliers", "GET")
export class GetUserSuppliers extends BaseRequest implements IReturn<GetUserSuppliersResponse>
{
    createResponse() { return new GetUserSuppliersResponse(); }
    getTypeName() { return "GetUserSuppliers"; }
}

// @Route("/api.v1/suppliers/{Id}", "GET")
export class GetSupplier extends BaseRequest implements IReturn<GetSupplierResponse>
{
    id: number;
    createResponse() { return new GetSupplierResponse(); }
    getTypeName() { return "GetSupplier"; }
}

// @Route("/api.v1/suppliers/preferred", "GET")
export class GetPreferredSuppliers extends BaseRequest implements IReturn<GetPreferredSuppliersResponse>
{
    productPurchaseUrl: string;
    createResponse() { return new GetPreferredSuppliersResponse(); }
    getTypeName() { return "GetPreferredSuppliers"; }
}

// @Route("/api.v1/suppliers", "POST")
export class CreateSupplier extends BaseRequest implements IReturn<CreateSupplierResponse>
{
    name: string;
    supplierTypeId: number;
    description: string;
    url: string;
    address: Address;
    phone: string;
    email: string;
    contactName: string;
    taxNumber: string;
    paymentType: PaymentTypes;
    paymentAccount: string;
    media: string[];
    referralFee: number;
    parentSupplierId: number;
    supplierRole: SupplierRole;
    autoAccept: boolean;
    orderEmail: string;
    supportEmail: string;
    returnAddress: Address;
    returnInstructions: string;
    returnEmail: string;
    zendeskHost: string;
    zendeskApiToken: string;
    zendeskAgentEmail: string;
    affiliateCode: string;
    referralOptInName: string;
    referralOptInRole: string;
    referralOptInDate: string;
    returnsUrl: string;
    termsUrl: string;
    tradeUrl: string;
    linkRate: number;
    linkMin: number;
    linkMax: number;
    spendCap: number;
    referralRateStandard: number;
    referralRateHigh: number;
    referralRateLow: number;
    webUrl1: string;
    webUrl2: string;
    bankAccountSort: string;
    bankAccountNumber: string;
    permission: Permissions;
    comment: string;
    discount: number;
    platformFee: number;
    parentPublisherId: number;
    parentWebsiteId: number;
    preferredAffiliateSchemeId: number;
    defaultDeliveryCharge: number;
    freeDeliveryThreshold: number;
    additionalWebsites: string[];
    createResponse() { return new CreateSupplierResponse(); }
    getTypeName() { return "CreateSupplier"; }
}

// @Route("/api.v1/suppliers/{Id}", "POST")
export class UpdateSupplier extends BaseRequest implements IReturn<UpdateSupplierResponse>
{
    id: number;
    name: string;
    supplierTypeId: number;
    description: string;
    url: string;
    address: Address;
    phone: string;
    email: string;
    contactName: string;
    taxNumber: string;
    paymentType: PaymentTypes;
    paymentAccount: string;
    media: string[];
    referralFee: number;
    parentSupplierId: number;
    supplierRole: SupplierRole;
    autoAccept: boolean;
    orderEmail: string;
    supportEmail: string;
    returnAddress: Address;
    returnInstructions: string;
    returnEmail: string;
    zendeskHost: string;
    zendeskApiToken: string;
    zendeskAgentEmail: string;
    affiliateCode: string;
    referralOptInName: string;
    referralOptInRole: string;
    referralOptInDate: string;
    returnsUrl: string;
    termsUrl: string;
    tradeUrl: string;
    linkRate: number;
    linkMin: number;
    linkMax: number;
    spendCap: number;
    referralRateStandard: number;
    referralRateHigh: number;
    referralRateLow: number;
    webUrl1: string;
    webUrl2: string;
    bankAccountSort: string;
    bankAccountNumber: string;
    permission: Permissions;
    comment: string;
    discount: number;
    platformFee: number;
    parentPublisherId: number;
    parentWebsiteId: number;
    preferredAffiliateSchemeId: number;
    defaultDeliveryCharge: number;
    freeDeliveryThreshold: number;
    additionalWebsites: string[];
    createResponse() { return new UpdateSupplierResponse(); }
    getTypeName() { return "UpdateSupplier"; }
}

// @Route("/api.v1/suppliers/{Id}", "DELETE")
export class DeleteSupplier extends BaseRequest implements IReturn<DeleteSupplierResponse>
{
    id: number;
    createResponse() { return new DeleteSupplierResponse(); }
    getTypeName() { return "DeleteSupplier"; }
}

// @Route("/api.v1/suppliers/{Id}/emails", "POST")
export class VerifySupplierEmail extends BaseRequest implements IReturn<VerifySupplierEmailResponse>
{
    id: number;
    email: string;
    field: string;
    createResponse() { return new VerifySupplierEmailResponse(); }
    getTypeName() { return "VerifySupplierEmail"; }
}

export class GetSupplierAffiliateSchemes extends BaseRequest implements IReturn<GetSupplierAffiliateSchemesResponse>
{
    supplierId: number;
    createResponse() { return new GetSupplierAffiliateSchemesResponse(); }
    getTypeName() { return "GetSupplierAffiliateSchemes"; }
}

// @Route("/api.v1/suppliers/types")
export class GetSupplierTypes extends BaseRequest implements IReturn<GetSupplierTypesResponse>
{
    createResponse() { return new GetSupplierTypesResponse(); }
    getTypeName() { return "GetSupplierTypes"; }
}

// @Route("/auth/stripe", "GET")
export class StripeAuthorisation implements IReturn<StripeAuthorisationResponse>
{
    scope: string;
    code: string;
    state: StripeState;
    createResponse() { return new StripeAuthorisationResponse(); }
    getTypeName() { return "StripeAuthorisation"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/stripe/deauth", "POST")
export class StripeDeauthorise implements IReturn<StripeDeauthoriseResponse>
{
    supplierId: number;
    createResponse() { return new StripeDeauthoriseResponse(); }
    getTypeName() { return "StripeDeauthorise"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/stripe/create", "POST")
export class SupplierCreateManagedStripe implements IReturn<SupplierCreateManagedStripeResponse>
{
    supplierId: number;
    bank: BankAccount;
    createResponse() { return new SupplierCreateManagedStripeResponse(); }
    getTypeName() { return "SupplierCreateManagedStripe"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/tasks", "GET")
export class GetSupplierTasks extends BaseRequest implements IReturn<GetSupplierTasksResponse>
{
    supplierId: number;
    taskId: number;
    createResponse() { return new GetSupplierTasksResponse(); }
    getTypeName() { return "GetSupplierTasks"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/tasks/{TaskId}", "GET")
export class GetSupplierTask extends BaseRequest implements IReturn<GetSupplierTaskResponse>
{
    supplierId: number;
    taskId: number;
    createResponse() { return new GetSupplierTaskResponse(); }
    getTypeName() { return "GetSupplierTask"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/taxrate", "POST")
export class SupplierTaxRate extends BaseRequest implements IReturn<SupplierTaxRateResponse>, IPost
{
    supplierId: number;
    taxCode: TaxCodes;
    date: string;
    createResponse() { return new SupplierTaxRateResponse(); }
    getTypeName() { return "SupplierTaxRate"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/users", "GET")
export class GetSupplierUsers extends BaseRequest implements IReturn<GetSupplierUsersResponse>
{
    role: string;
    supplierId: number;
    publisherId: number;
    createResponse() { return new GetSupplierUsersResponse(); }
    getTypeName() { return "GetSupplierUsers"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/users/{Id}", "GET")
export class GetSupplierUser extends BaseRequest implements IReturn<GetSupplierUserResponse>
{
    supplierId: number;
    id: number;
    loginsCount: number;
    createResponse() { return new GetSupplierUserResponse(); }
    getTypeName() { return "GetSupplierUser"; }
}

// @Route("/api.v1/verticals", "GET")
export class GetVerticals extends BaseRequest implements IReturn<GetVerticalsResponse>
{
    createResponse() { return new GetVerticalsResponse(); }
    getTypeName() { return "GetVerticals"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/verticals", "GET")
export class GetSupplierVerticals extends BaseRequest implements IReturn<GetSupplierVerticalsResponse>, IGet
{
    supplierId: number;
    createResponse() { return new GetSupplierVerticalsResponse(); }
    getTypeName() { return "GetSupplierVerticals"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/verticals", "POST")
export class CreateSupplierVertical extends BaseRequest implements IReturn<CreateSupplierVerticalResponse>, IPost
{
    supplierId: number;
    vertical: string;
    createResponse() { return new CreateSupplierVerticalResponse(); }
    getTypeName() { return "CreateSupplierVertical"; }
}

// @Route("/api.v1/suppliers/{SupplierId}/verticals/{VerticalId}", "DELETE")
export class RemoveSupplierVertical extends BaseRequest implements IReturn<GetSupplierVerticalsResponse>, IDelete
{
    supplierId: number;
    verticalId: number;
    createResponse() { return new GetSupplierVerticalsResponse(); }
    getTypeName() { return "RemoveSupplierVertical"; }
}

// @Route("/{Path*}", "GET")
export class Root extends BaseRequest implements IReturn<RootResponse>
{
    path: string;
    version: string;
    createResponse() { return new RootResponse(); }
    getTypeName() { return "Root"; }
}

// @Route("/status", "GET,POST")
export class Status extends BaseRequest implements IReturn<StatusResponse>
{
    createResponse() { return new StatusResponse(); }
    getTypeName() { return "Status"; }
}

// @Route("/redirect", "GET,POST")
export class RedirectRequest extends BaseRequest implements IReturn<RedirectResponse>
{
    url: string;
    createResponse() { return new RedirectResponse(); }
    getTypeName() { return "RedirectRequest"; }
}

// @Route("/api.v1/user", "POST")
export class GetCurrentUser extends BaseRequest implements IReturn<GetCurrentUserResponse>
{
    createResponse() { return new GetCurrentUserResponse(); }
    getTypeName() { return "GetCurrentUser"; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    provider: string;

    // @DataMember(Order=2)
    state: string;

    // @DataMember(Order=3)
    oauth_token: string;

    // @DataMember(Order=4)
    oauth_verifier: string;

    // @DataMember(Order=5)
    userName: string;

    // @DataMember(Order=6)
    password: string;

    // @DataMember(Order=7)
    rememberMe: boolean;

    // @DataMember(Order=8)
    continue: string;

    // @DataMember(Order=9)
    nonce: string;

    // @DataMember(Order=10)
    uri: string;

    // @DataMember(Order=11)
    response: string;

    // @DataMember(Order=12)
    qop: string;

    // @DataMember(Order=13)
    nc: string;

    // @DataMember(Order=14)
    cnonce: string;

    // @DataMember(Order=15)
    useTokenCookie: boolean;

    // @DataMember(Order=16)
    accessToken: string;

    // @DataMember(Order=17)
    accessTokenSecret: string;

    // @DataMember(Order=18)
    meta: { [index:string]: string; };
    createResponse() { return new AuthenticateResponse(); }
    getTypeName() { return "Authenticate"; }
}

// @Route("/login", "GET")
export class LoginAuth extends Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    error: string;
    createResponse() { return new AuthenticateResponse(); }
    getTypeName() { return "LoginAuth"; }
}

// @Route("/logout", "GET")
export class Logout extends BaseRequest
{
    continue: string;
}

// @Route("/api.v1/verify", "GET")
export class EmailVerification extends BaseRequest implements IReturn<EmailVerificationResponse>
{
    token: string;
    createResponse() { return new EmailVerificationResponse(); }
    getTypeName() { return "EmailVerification"; }
}

// @Route("/home", "GET")
export class Home implements IReturn<HomeResponse>
{
    createResponse() { return new HomeResponse(); }
    getTypeName() { return "Home"; }
}

// @Route("/editors/{Path*}", "GET")
export class AdminHome extends BaseRequest implements IReturn<AdminHomeResponse>
{
    header: boolean;
    sidebar: boolean;
    footer: boolean;
    path: string;
    createResponse() { return new AdminHomeResponse(); }
    getTypeName() { return "AdminHome"; }
}

// @Route("/postregister", "GET")
// @Route("/postregister", "POST")
export class PostRegister implements IReturn<PostRegisterResponse>
{
    fullName: string;
    email: string;
    createResponse() { return new PostRegisterResponse(); }
    getTypeName() { return "PostRegister"; }
}

// @Route("/api.v1/users", "GET")
// @Route("/api.v1/publishers/{publisherId}/users", "GET")
export class GetUsers extends BaseRequest implements IReturn<GetUsersResponse>
{
    role: string;
    supplierId: number;
    publisherId: number;
    createResponse() { return new GetUsersResponse(); }
    getTypeName() { return "GetUsers"; }
}

// @Route("/api.v1/users/exists", "POST")
export class CheckExistingUser extends BaseRequest implements IReturn<CheckExistingUserResponse>
{
    userName: string;
    createResponse() { return new CheckExistingUserResponse(); }
    getTypeName() { return "CheckExistingUser"; }
}

// @Route("/api.v1/passwords", "POST")
export class CheckCommonPassword extends BaseRequest implements IReturn<CheckCommonPasswordResponse>
{
    password: string;
    createResponse() { return new CheckCommonPasswordResponse(); }
    getTypeName() { return "CheckCommonPassword"; }
}

// @Route("/api.v1/taxcodes/{Country}", "GET")
export class GetTaxCodes extends BaseRequest implements IReturn<GetTaxCodesResponse>
{
    country: string;
    createResponse() { return new GetTaxCodesResponse(); }
    getTypeName() { return "GetTaxCodes"; }
}

// @Route("/api.v1/trackers/{Country}", "GET")
export class GetDeliveryTrackers extends BaseRequest implements IReturn<GetDeliveryTrackersResponse>
{
    country: string;
    createResponse() { return new GetDeliveryTrackersResponse(); }
    getTypeName() { return "GetDeliveryTrackers"; }
}

// @Route("/api.v1/users/{Id}", "GET")
export class GetUser extends BaseRequest implements IReturn<GetUserResponse>
{
    id: number;
    loginsCount: number;
    createResponse() { return new GetUserResponse(); }
    getTypeName() { return "GetUser"; }
}

// @Route("/api.v1/publishers/{PublisherId}/users/{Id}", "GET")
// @Route("/api.v1/users/{Id}", "GET")
export class GetPublisherUser extends GetUser implements IReturn<GetUserResponse>
{
    publisherId: number;
    createResponse() { return new GetUserResponse(); }
    getTypeName() { return "GetPublisherUser"; }
}

// @Route("/api.v1/user/paymentmethods", "GET")
// @Route("/api.v1/users/{UserId}/paymentmethods", "GET")
export class GetPaymentMethods extends BaseRequest implements IReturn<GetPaymentMethodsResponse>
{
    userId: number;
    createResponse() { return new GetPaymentMethodsResponse(); }
    getTypeName() { return "GetPaymentMethods"; }
}

// @Route("/api.v1/user/paymentmethods/{Id}", "GET")
// @Route("/api.v1/users/{UserId}/paymentmethods/{Id}", "GET")
export class GetPaymentMethod extends BaseRequest implements IReturn<GetPaymentMethodResponse>
{
    userId: number;
    id: number;
    createResponse() { return new GetPaymentMethodResponse(); }
    getTypeName() { return "GetPaymentMethod"; }
}

// @Route("/api.v1/user/paymentmethods", "POST")
// @Route("/api.v1/users/{UserId}/paymentmethods", "POST")
export class AddPaymentMethod extends BaseRequest implements IReturn<AddPaymentMethodResponse>
{
    userId: number;
    name: string;
    paymentType: PaymentTypes;
    token: string;
    isDefault: boolean;
    createResponse() { return new AddPaymentMethodResponse(); }
    getTypeName() { return "AddPaymentMethod"; }
}

// @Route("/api.v1/user/paymentmethods/{Id}", "POST")
// @Route("/api.v1/users/{UserId}/paymentmethods/{Id}", "POST")
export class UpdatePaymentMethod extends BaseRequest implements IReturn<UpdatePaymentMethodResponse>
{
    userId: number;
    id: number;
    isDefault: boolean;
    createResponse() { return new UpdatePaymentMethodResponse(); }
    getTypeName() { return "UpdatePaymentMethod"; }
}

// @Route("/api.v1/user/paymentmethods/{Id}", "DELETE")
// @Route("/api.v1/users/{UserId}/paymentmethods/{Id}", "DELETE")
export class DeletePaymentMethod extends BaseRequest implements IReturn<DeletePaymentMethodResponse>
{
    userId: number;
    id: number;
    createResponse() { return new DeletePaymentMethodResponse(); }
    getTypeName() { return "DeletePaymentMethod"; }
}

// @Route("/api.v1/user/recipients", "GET")
// @Route("/api.v1/users/{UserId}/recipients", "GET")
export class GetRecipients extends BaseRequest implements IReturn<GetRecipientsResponse>
{
    userId: number;
    createResponse() { return new GetRecipientsResponse(); }
    getTypeName() { return "GetRecipients"; }
}

// @Route("/api.v1/user/recipients/{Id}", "GET")
// @Route("/api.v1/users/{UserId}/recipients/{Id}", "GET")
export class GetRecipient extends BaseRequest implements IReturn<GetRecipientResponse>
{
    userId: number;
    id: number;
    createResponse() { return new GetRecipientResponse(); }
    getTypeName() { return "GetRecipient"; }
}

// @Route("/api.v1/user/recipients", "POST")
// @Route("/api.v1/users/{UserId}/recipients", "POST")
export class AddRecipient extends BaseRequest implements IReturn<AddRecipientResponse>
{
    userId: number;
    name: string;
    fullName: string;
    address: Address;
    email: string;
    phone: string;
    isDefault: boolean;
    createResponse() { return new AddRecipientResponse(); }
    getTypeName() { return "AddRecipient"; }
}

// @Route("/api.v1/user/recipients/{Id}", "POST")
// @Route("/api.v1/users/{UserId}/recipients/{Id}", "POST")
export class UpdateRecipient extends BaseRequest implements IReturn<UpdateRecipientResponse>
{
    userId: number;
    id: number;
    name: string;
    fullName: string;
    address: Address;
    email: string;
    phone: string;
    isDefault: boolean;
    createResponse() { return new UpdateRecipientResponse(); }
    getTypeName() { return "UpdateRecipient"; }
}

// @Route("/api.v1/user/recipients/{Id}", "DELETE")
// @Route("/api.v1/users/{UserId}/recipients/{Id}", "DELETE")
export class DeleteRecipient extends BaseRequest implements IReturn<DeleteRecipientResponse>
{
    userId: number;
    id: number;
    createResponse() { return new DeleteRecipientResponse(); }
    getTypeName() { return "DeleteRecipient"; }
}

// @Route("/api.v1/roles", "GET")
export class GetRoles extends BaseRequest implements IReturn<GetRolesResponse>
{
    createResponse() { return new GetRolesResponse(); }
    getTypeName() { return "GetRoles"; }
}

// @Route("/api.v1/shared", "POST")
export class UserShared extends BaseRequest implements IReturn<UserSharedResponse>
{
    token: string;
    createResponse() { return new UserSharedResponse(); }
    getTypeName() { return "UserShared"; }
}

// @Route("/api.v1/websites/{WebsiteId}/suppliers", "GET")
export class GetWebsiteSuppliers extends BaseRequest implements IReturn<GetWebsiteSuppliersResponse>
{
    websiteId: number;
    createResponse() { return new GetWebsiteSuppliersResponse(); }
    getTypeName() { return "GetWebsiteSuppliers"; }
}

// @Route("/api.v1/websites/{WebsiteId}/suppliers", "POST")
export class CreateWebsiteSupplier extends BaseRequest implements IReturn<CreateWebsiteSupplierResponse>
{
    websiteId: number;
    supplierId: number;
    createResponse() { return new CreateWebsiteSupplierResponse(); }
    getTypeName() { return "CreateWebsiteSupplier"; }
}

// @Route("/api.v1/websites/{WebsiteId}/suppliers/{SupplierId}", "DELETE")
export class DeleteWebsiteSupplier extends BaseRequest implements IReturn<DeleteWebsiteSupplierResponse>
{
    websiteId: number;
    supplierId: number;
    createResponse() { return new DeleteWebsiteSupplierResponse(); }
    getTypeName() { return "DeleteWebsiteSupplier"; }
}

export class SetOrderDelivered extends BaseRequest implements IReturn<SetOrderDeliveredResponse>
{
    orderId: number;
    isoDate: string;
    createResponse() { return new SetOrderDeliveredResponse(); }
    getTypeName() { return "SetOrderDelivered"; }
}

export class SetOrderReturnRequested extends BaseRequest implements IReturn<SetOrderReturnRequestedResponse>
{
    orderId: number;
    isoDate: string;
    createResponse() { return new SetOrderReturnRequestedResponse(); }
    getTypeName() { return "SetOrderReturnRequested"; }
}

export class SetOrderRefunded extends BaseRequest implements IReturn<SetOrderRefundedResponse>
{
    orderId: number;
    amount: number;
    reason: string;
    createResponse() { return new SetOrderRefundedResponse(); }
    getTypeName() { return "SetOrderRefunded"; }
}

export class SendOrderCustomerMessage extends BaseRequest implements IReturn<SendOrderCustomerMessageResponse>
{
    orderId: number;
    subject: string;
    message: string;
    createResponse() { return new SendOrderCustomerMessageResponse(); }
    getTypeName() { return "SendOrderCustomerMessage"; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    userName: string;

    // @DataMember(Order=2)
    permissions: string[];

    // @DataMember(Order=3)
    roles: string[];
    createResponse() { return new AssignRolesResponse(); }
    getTypeName() { return "AssignRoles"; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    userName: string;

    // @DataMember(Order=2)
    permissions: string[];

    // @DataMember(Order=3)
    roles: string[];
    createResponse() { return new UnAssignRolesResponse(); }
    getTypeName() { return "UnAssignRoles"; }
}

// @Route("/session-to-token")
// @DataContract
export class ConvertSessionToToken implements IReturn<ConvertSessionToTokenResponse>, IPost
{
    // @DataMember(Order=1)
    preserveSession: boolean;
    createResponse() { return new ConvertSessionToTokenResponse(); }
    getTypeName() { return "ConvertSessionToToken"; }
}

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    // @DataMember(Order=1)
    refreshToken: string;
    createResponse() { return new GetAccessTokenResponse(); }
    getTypeName() { return "GetAccessToken"; }
}
